/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../notification/message/message.component.ngfactory';
import * as import2 from '../../notification/message/message.component';
import * as import3 from '../../notification/notification.service';
import * as import4 from '../../buttons/link/link.component.ngfactory';
import * as import5 from '../../buttons/link/link.component';
import * as import6 from '../../order/order-details-panel/order-details-panel.component.ngfactory';
import * as import7 from '../../order/order-details-panel/order-details-panel.component';
import * as import8 from '../../orchestration/session.model';
import * as import9 from '../../ordering-context/ordering-context.model';
import * as import10 from '../../order/order.model';
import * as import11 from '../../orchestration/navigation.service';
import * as import12 from '../../orchestration/responsive.directive';
import * as import13 from '../../orchestration/responsive.service';
import * as import14 from '../../ordering-context/ordering-context-panel/ordering-context-panel.component.ngfactory';
import * as import15 from '../../ordering-context/ordering-context-panel/ordering-context-panel.component';
import * as import16 from '@angular/common';
import * as import17 from '../../inputs/radio-field/radio-field.component.ngfactory';
import * as import18 from '../../inputs/radio-field/radio-field.component';
import * as import19 from '../../ui-elements/icon/icon.component.ngfactory';
import * as import20 from '../../ui-elements/icon/icon.component';
import * as import21 from '../../ui-elements/card-brand/card-brand.component.ngfactory';
import * as import22 from '../../ui-elements/card-brand/card-brand.component';
import * as import23 from '../card-payment/stripe-manual-payment-card-panel/stripe-manual-payment-card-panel.component.ngfactory';
import * as import24 from '../card-payment/stripe-manual-payment-card-panel/stripe-manual-payment-card-panel.component';
import * as import25 from '../payment.model';
import * as import26 from '../payment';
import * as import27 from '../card-payment/tyro-manual-payment-card-panel/tyro-manual-payment-card-panel.component.ngfactory';
import * as import28 from '../card-payment/tyro-manual-payment-card-panel/tyro-manual-payment-card-panel.component';
import * as import29 from '../../theme/theme.model';
import * as import30 from '../card-payment/adyen-manual-payment-card-panel/adyen-manual-payment-card-panel.component.ngfactory';
import * as import31 from '../card-payment/adyen-manual-payment-card-panel/adyen-manual-payment-card-panel.component';
import * as import32 from '../../inputs/form/field-group/field-group.component.ngfactory';
import * as import33 from '../../inputs/form/field-group/field-group.component';
import * as import34 from '@angular/forms';
import * as import35 from '../card-payment/stripe-scanned-payment-card-panel/stripe-scanned-payment-card-panel.component.ngfactory';
import * as import36 from '../card-payment/stripe-scanned-payment-card-panel/stripe-scanned-payment-card-panel.component';
import * as import37 from 'ng2-translate/src/translate.service';
import * as import38 from '@angular/http';
import * as import39 from '../../inputs/form/form.component';
import * as import40 from '../../inputs/phone-number-field/phone-number-field.component.ngfactory';
import * as import41 from '../../inputs/phone-number-field/phone-number.directive';
import * as import42 from '../../inputs/phone-number-field/phone-number-field.component';
import * as import43 from '../../inputs/text-area-field/text-area-field.component.ngfactory';
import * as import44 from '../../inputs/text-area-field/text-area-field.component';
import * as import45 from '../../inputs/form/field-pair/field-pair.component.ngfactory';
import * as import46 from '../../inputs/form/field-pair/field-pair.component';
import * as import47 from '../../inputs/text-field/text-field.component.ngfactory';
import * as import48 from '../../inputs/text-field/text-field.component';
import * as import49 from '../../inputs/email-field/email-field.component.ngfactory';
import * as import50 from '../../inputs/email-field/email.directive';
import * as import51 from '../../inputs/email-field/email-field.component';
import * as import52 from '../../inputs/selector-control/selector-control.component.ngfactory';
import * as import53 from '../../inputs/selector-control/selector-control.component';
import * as import54 from '../tip-selection-panel/tip-selection-panel.component.ngfactory';
import * as import55 from '../tip-selection-panel/tip-selection-panel.component';
import * as import56 from '../../buttons/button/button.component.ngfactory';
import * as import57 from '../../buttons/button/button.component';
import * as import58 from '../../page-layout/page-footer-control.directive';
import * as import59 from '../../buttons/apple-pay-button/apple-pay-button.component.ngfactory';
import * as import60 from '../../buttons/apple-pay-button/apple-pay-button.component';
import * as import61 from '../../buttons/google-pay-button/google-pay-button.component.ngfactory';
import * as import62 from '../../buttons/google-pay-button/google-pay-button.component';
import * as import63 from '../../string-utils/possessive.pipe';
import * as import64 from '../../string-utils/currency.pipe';
import * as import65 from '../../page-layout/full-page-layout/full-page-layout.component.ngfactory';
import * as import66 from '../../page-layout/full-page-layout/full-page-layout.component';
import * as import67 from '../../orchestration/page';
import * as import68 from './payment-page.component';
import * as import69 from '../../inputs/form/form.component.ngfactory';
import * as import70 from '../../order/order-totals-panel/order-totals-panel.component.ngfactory';
import * as import71 from '../../order/order-totals-panel/order-totals-panel.component';
import * as import72 from '../../legal/legal-panel/legal-panel.component.ngfactory';
import * as import73 from '../../legal/legal-panel/legal-panel.component';
import * as import74 from '../../orchestration/analytics.service';
import * as import75 from '../../orchestration/navigation-params';
import * as import76 from '../../orchestration/session.controller';
import * as import77 from '../../group-order/group-order.model';
import * as import78 from '../../identity/identity.model';
import * as import79 from '../../ui-elements/loading/loading.service';
import * as import80 from '@fedelta-pos/data-client/configuration/local-configuration.service';
import * as import81 from '../card-payment/card-scan.service';
import * as import82 from '../../customer-info/customer-details.service';
const styles_PaymentPageComponent:any[] = ([] as any[]);
export const RenderType_PaymentPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_PaymentPageComponent,
  data: {}
}
);
function View_PaymentPageComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'woa-content-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_ContentMessageComponent_0,import1.RenderType_ContentMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import2.ContentMessageComponent,[
      import0.ElementRef,
      import3.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,8,{links: 1}),
    (l()(),import0.ɵted(0,['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),1,1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.load()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import4.View_LinkComponent_0,import4.RenderType_LinkComponent)),
      import0.ɵdid(49152,[[
        8,
        4
      ]
      ],0,import5.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted(0,['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.ERROR;
    const currVal_9:any = 'woa.error.order.initiationFailed';
    ck(v,1,0,currVal_8,currVal_9);
    const currVal_10:any = 'woa.button.common.retry';
    ck(v,5,0,currVal_10);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_PaymentPageComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-details-panel',[
      [
        'class',
        'order-details'
      ]
      ,
      [
        'slot',
        'content-left'
      ]

    ]
    ,(null as any),(null as any),(null as any),import6.View_OrderDetailsPanelComponent_0,import6.RenderType_OrderDetailsPanelComponent)),
    import0.ɵdid(573440,(null as any),0,import7.OrderDetailsPanelComponent,[
      import8.SessionModel,
      import9.OrderingContextModel,
      import10.OrderModel,
      import11.NavigationService
    ]
    ,{
      recentOrder: [
        0,
        'recentOrder'
      ]
      ,
      showPayment: [
        1,
        'showPayment'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.recentOrder;
    const currVal_1:any = false;
    ck(v,1,0,currVal_0,currVal_1);
  },(null as any));
}
function View_PaymentPageComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-content-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'onClose'
      ]
      ,
      [
        (null as any),
        'click'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('onClose' === en)) {
        const pd_1:any = ((<any>(co.orderModel.orderErrorStates.orderWithInvalidTimeAttempted = false)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import1.View_ContentMessageComponent_0,import1.RenderType_ContentMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import2.ContentMessageComponent,[
      import0.ElementRef,
      import3.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]
      ,
      translationParams: [
        2,
        'translationParams'
      ]
      ,
      closable: [
        3,
        'closable'
      ]

    }
    ,{onClose: 'onClose'}),
    import0.ɵqud(603979776,9,{links: 1}),
    import0.ɵpod(['storeName'])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.ERROR;
    const currVal_9:any = co.orderModel.invalidOrderTimeMessage;
    const currVal_10:any = ck(v,3,0,((co.orderingContextModel.currentStore == null)? (null as any): co.orderingContextModel.currentStore.name));
    const currVal_11:any = true;
    ck(v,1,0,currVal_8,currVal_9,currVal_10,currVal_11);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_PaymentPageComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[
      [
        'class',
        'ordering-context'
      ]
      ,
      [
        'slot',
        'content-right'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(737280,(null as any),0,import12.ResponsiveDirective,[
      import0.ElementRef,
      import13.ResponsiveService,
      import11.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-ordering-context-panel',([] as any[]),(null as any),(null as any),(null as any),import14.View_OrderingContextPanelComponent_0,import14.RenderType_OrderingContextPanelComponent)),
    import0.ɵdid(245760,(null as any),0,import15.OrderingContextPanelComponent,[
      import9.OrderingContextModel,
      import10.OrderModel,
      import13.ResponsiveService,
      import11.NavigationService,
      import0.ChangeDetectorRef
    ]
      ,{timeOnly: [
        0,
        'timeOnly'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PaymentPageComponent_4)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    ck(v,1,0);
    const currVal_0:any = true;
    ck(v,4,0,currVal_0);
    const currVal_1:any = co.orderModel.orderErrorStates.orderWithInvalidTimeAttempted;
    ck(v,7,0,currVal_1);
  },(null as any));
}
function View_PaymentPageComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'woa-radio-field',([] as any[]),[[
        2,
        'disabled',
        (null as any)
      ]
      ],[[
        (null as any),
        'selectedChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('selectedChange' === en)) {
        const pd_0:any = ((<any>co.selectTransferTarget(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import17.View_RadioFieldComponent_0,import17.RenderType_RadioFieldComponent)),
    import0.ɵdid(1097728,(null as any),0,import18.RadioFieldComponent,[import0.ElementRef],{
      label: [
        0,
        'label'
      ]
      ,
      translationParams: [
        1,
        'translationParams'
      ]
      ,
      selected: [
        2,
        'selected'
      ]

    }
    ,{selectedChange: 'selectedChange'}),
    import0.ɵppd(1),
    import0.ɵpod(['groupOrderName']),
    (l()(),import0.ɵted(0,['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),0,1,'woa-icon',([] as any[]),(null as any),(null as any),(null as any),import19.View_IconComponent_0,import19.RenderType_IconComponent)),
      import0.ɵdid(573440,(null as any),0,import20.IconComponent,[import0.ChangeDetectorRef],{name: [
        0,
        'name'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = 'woa.label.payment.payWithGroupOrder';
    const currVal_2:any = ck(v,3,0,import0.ɵunv(v,1,1,ck(v,2,0,import0.ɵnov((<any>(<any>v.parent).parent),0),v.context.$implicit.name)));
    const currVal_3:any = ((co.paymentType === co.PaymentType.GROUP_PAY) && (co.transferTarget === v.context.$implicit));
    ck(v,1,0,currVal_1,currVal_2,currVal_3);
    const currVal_4:any = 'users';
    ck(v,6,0,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    ck(v,0,0,currVal_0);
  });
}
function View_PaymentPageComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'woa-radio-field',([] as any[]),[[
        2,
        'disabled',
        (null as any)
      ]
      ],[[
        (null as any),
        'selectedChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('selectedChange' === en)) {
        const pd_0:any = ((<any>(co.paymentType = co.PaymentType.APPLE_PAY)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import17.View_RadioFieldComponent_0,import17.RenderType_RadioFieldComponent)),
    import0.ɵdid(1097728,(null as any),0,import18.RadioFieldComponent,[import0.ElementRef],{
      label: [
        0,
        'label'
      ]
      ,
      selected: [
        1,
        'selected'
      ]

    }
    ,{selectedChange: 'selectedChange'}),
    (l()(),import0.ɵted(0,['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),0,1,'woa-icon',[[
        'class',
        'apple-pay-mark'
      ]
    ],(null as any),(null as any),(null as any),import19.View_IconComponent_0,import19.RenderType_IconComponent)),
      import0.ɵdid(573440,(null as any),0,import20.IconComponent,[import0.ChangeDetectorRef],{name: [
        0,
        'name'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = 'woa.label.payment.payWithApplePay';
    const currVal_2:any = (co.paymentType === co.PaymentType.APPLE_PAY);
    ck(v,1,0,currVal_1,currVal_2);
    const currVal_3:any = 'apple-pay-mark';
    ck(v,4,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    ck(v,0,0,currVal_0);
  });
}
function View_PaymentPageComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'woa-radio-field',([] as any[]),[[
        2,
        'disabled',
        (null as any)
      ]
      ],[[
        (null as any),
        'selectedChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('selectedChange' === en)) {
        const pd_0:any = ((<any>(co.paymentType = co.PaymentType.GOOGLE_PAY)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import17.View_RadioFieldComponent_0,import17.RenderType_RadioFieldComponent)),
    import0.ɵdid(1097728,(null as any),0,import18.RadioFieldComponent,[import0.ElementRef],{
      label: [
        0,
        'label'
      ]
      ,
      selected: [
        1,
        'selected'
      ]

    }
    ,{selectedChange: 'selectedChange'}),
    (l()(),import0.ɵted(0,['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),0,1,'woa-icon',[[
        'class',
        'google-pay-mark'
      ]
    ],(null as any),(null as any),(null as any),import19.View_IconComponent_0,import19.RenderType_IconComponent)),
      import0.ɵdid(573440,(null as any),0,import20.IconComponent,[import0.ChangeDetectorRef],{name: [
        0,
        'name'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = 'woa.label.payment.payWithGooglePay';
    const currVal_2:any = (co.paymentType === co.PaymentType.GOOGLE_PAY);
    ck(v,1,0,currVal_1,currVal_2);
    const currVal_3:any = 'google-pay-mark';
    ck(v,4,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    ck(v,0,0,currVal_0);
  });
}
function View_PaymentPageComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'woa-radio-field',([] as any[]),[[
        2,
        'disabled',
        (null as any)
      ]
      ],[[
        (null as any),
        'selectedChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('selectedChange' === en)) {
        const pd_0:any = ((<any>(co.paymentType = co.PaymentType.SAVED_CREDIT_CARD)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import17.View_RadioFieldComponent_0,import17.RenderType_RadioFieldComponent)),
    import0.ɵdid(1097728,(null as any),0,import18.RadioFieldComponent,[import0.ElementRef],{
      label: [
        0,
        'label'
      ]
      ,
      translationParams: [
        1,
        'translationParams'
      ]
      ,
      selected: [
        2,
        'selected'
      ]

    }
    ,{selectedChange: 'selectedChange'}),
    import0.ɵpod(['cardLast4']),
    (l()(),import0.ɵted(0,['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),0,1,'woa-card-brand',[[
        'class',
        'card-brand'
      ]
    ],(null as any),(null as any),(null as any),import21.View_CardBrandComponent_0,import21.RenderType_CardBrandComponent)),
      import0.ɵdid(573440,(null as any),0,import22.CardBrandComponent,([] as any[]),{brand: [
        0,
        'brand'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),1,1,'woa-link',[[
        'slot',
        'action'
      ]
      ],(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.forgetCard()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import4.View_LinkComponent_0,import4.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import5.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted(0,['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = 'woa.label.payment.payWithSavedCard';
    const currVal_2:any = ck(v,2,0,co.paymentModel.cardLast4);
    const currVal_3:any = (co.paymentType === co.PaymentType.SAVED_CREDIT_CARD);
    ck(v,1,0,currVal_1,currVal_2,currVal_3);
    const currVal_4:any = co.paymentModel.cardBrand;
    ck(v,5,0,currVal_4);
    const currVal_5:any = 'woa.button.payment.forgetCard';
    ck(v,8,0,currVal_5);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    ck(v,0,0,currVal_0);
  });
}
function View_PaymentPageComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,[[
        5,
        0
      ]
      ],(null as any),3,'woa-stripe-manual-payment-card-panel',[[
        'slot',
        'details'
      ]
    ],(null as any),(null as any),(null as any),import23.View_StripeManualPaymentCardPanelComponent_0,import23.RenderType_StripeManualPaymentCardPanelComponent)),
    import0.ɵdid(4964352,(null as any),0,import24.StripeManualPaymentCardPanelComponent,[
      import0.ElementRef,
      import8.SessionModel,
      import0.ChangeDetectorRef,
      import13.ResponsiveService,
      import25.PaymentModel
    ]
      ,{disabled: [
        0,
        'disabled'
      ]
    },(null as any)),
    import0.ɵpid(131072,import16.AsyncPipe,[import0.ChangeDetectorRef]),
      import0.ɵprd(2048,[[
        6,
        4
      ]
    ],import26.PaymentCard,(null as any),[import24.StripeManualPaymentCardPanelComponent])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(co.OrderEvents.orderSubmissionStatus$)) === co.OrderSubmissionStatus.SUBMITTING);
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_PaymentPageComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,[[
        5,
        0
      ]
      ],(null as any),3,'woa-tyro-manual-payment-card-panel',[[
        'slot',
        'details'
      ]
      ],[[
        2,
        'disabled',
        (null as any)
      ]
      ],[[
        (null as any),
        'onPayFormReady'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('onPayFormReady' === en)) {
        const pd_0:any = ((<any>import0.ɵnov((<any>v.parent),1).setHeight()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import27.View_TyroManualPaymentCardPanelComponent_0,import27.RenderType_TyroManualPaymentCardPanelComponent)),
    import0.ɵdid(4964352,(null as any),0,import28.TyroManualPaymentCardPanelComponent,[
      import0.ElementRef,
      import8.SessionModel,
      import0.ChangeDetectorRef,
      import13.ResponsiveService,
      import25.PaymentModel,
      import29.ThemeModel
    ]
    ,{
      disabled: [
        0,
        'disabled'
      ]
      ,
      hidden: [
        1,
        'hidden'
      ]

    }
    ,{onPayFormReady: 'onPayFormReady'}),
    import0.ɵpid(131072,import16.AsyncPipe,[import0.ChangeDetectorRef]),
      import0.ɵprd(2048,[[
        6,
        4
      ]
    ],import26.PaymentCard,(null as any),[import28.TyroManualPaymentCardPanelComponent])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = (import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(co.OrderEvents.orderSubmissionStatus$)) === co.OrderSubmissionStatus.SUBMITTING);
    const currVal_2:any = (co.paymentType !== co.PaymentType.NEW_CREDIT_CARD);
    ck(v,1,0,currVal_1,currVal_2);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    ck(v,0,0,currVal_0);
  });
}
function View_PaymentPageComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,[[
        5,
        0
      ]
      ],(null as any),3,'woa-adyen-manual-payment-card-panel',[[
        'slot',
        'details'
      ]
      ],[[
        2,
        'disabled',
        (null as any)
      ]
      ],[[
        (null as any),
        'onPayFormReady'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('onPayFormReady' === en)) {
        const pd_0:any = ((<any>import0.ɵnov((<any>v.parent),1).setHeight()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import30.View_AdyenManualPaymentCardPanelComponent_0,import30.RenderType_AdyenManualPaymentCardPanelComponent)),
    import0.ɵdid(4964352,(null as any),0,import31.AdyenManualPaymentCardPanelComponent,[
      import8.SessionModel,
      import0.ChangeDetectorRef,
      import13.ResponsiveService,
      import10.OrderModel,
      import25.PaymentModel
    ]
    ,{
      disabled: [
        0,
        'disabled'
      ]
      ,
      hidden: [
        1,
        'hidden'
      ]

    }
    ,{onPayFormReady: 'onPayFormReady'}),
    import0.ɵpid(131072,import16.AsyncPipe,[import0.ChangeDetectorRef]),
      import0.ɵprd(2048,[[
        6,
        4
      ]
    ],import26.PaymentCard,(null as any),[import31.AdyenManualPaymentCardPanelComponent])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = (import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(co.OrderEvents.orderSubmissionStatus$)) === co.OrderSubmissionStatus.SUBMITTING);
    const currVal_2:any = (co.paymentType !== co.PaymentType.NEW_CREDIT_CARD);
    ck(v,1,0,currVal_1,currVal_2);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    ck(v,0,0,currVal_0);
  });
}
function View_PaymentPageComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),20,'woa-radio-field',([] as any[]),[[
        2,
        'disabled',
        (null as any)
      ]
    ],[
      [
        (null as any),
        'selectedChange'
      ]
      ,
      [
        (null as any),
        'onActivateLabel'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('selectedChange' === en)) {
        const pd_0:any = ((<any>(co.paymentType = co.PaymentType.NEW_CREDIT_CARD)) !== false);
        ad = (pd_0 && ad);
      }
      if (('onActivateLabel' === en)) {
        const pd_1:any = ((<any>co.copyDefaultCardNr()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import17.View_RadioFieldComponent_0,import17.RenderType_RadioFieldComponent)),
      import0.ɵdid(1097728,[[
        'newCard',
        4
      ]
    ],0,import18.RadioFieldComponent,[import0.ElementRef],{
      label: [
        0,
        'label'
      ]
      ,
      softResizeOnSelect: [
        1,
        'softResizeOnSelect'
      ]
      ,
      selected: [
        2,
        'selected'
      ]

    }
    ,{
      selectedChange: 'selectedChange',
      onActivateLabel: 'onActivateLabel'
    }
    ),
    (l()(),import0.ɵted(0,['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),0,1,'woa-card-brand',[[
        'class',
        'card-brand'
      ]
    ],(null as any),(null as any),(null as any),import21.View_CardBrandComponent_0,import21.RenderType_CardBrandComponent)),
      import0.ɵdid(573440,(null as any),0,import22.CardBrandComponent,([] as any[]),{brand: [
        0,
        'brand'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),0,1,'woa-card-brand',[[
        'class',
        'card-brand'
      ]
    ],(null as any),(null as any),(null as any),import21.View_CardBrandComponent_0,import21.RenderType_CardBrandComponent)),
      import0.ɵdid(573440,(null as any),0,import22.CardBrandComponent,([] as any[]),{brand: [
        0,
        'brand'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),0,1,'woa-card-brand',[[
        'class',
        'card-brand'
      ]
    ],(null as any),(null as any),(null as any),import21.View_CardBrandComponent_0,import21.RenderType_CardBrandComponent)),
      import0.ɵdid(573440,(null as any),0,import22.CardBrandComponent,([] as any[]),{brand: [
        0,
        'brand'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),2,1,(null as any),View_PaymentPageComponent_11)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),2,1,(null as any),View_PaymentPageComponent_12)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),2,1,(null as any),View_PaymentPageComponent_13)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = (co.showSavedCreditCardPayment? 'woa.label.payment.payWithNewCard': 'woa.label.payment.payWithCard');
    const currVal_2:any = true;
    const currVal_3:any = (co.paymentType === co.PaymentType.NEW_CREDIT_CARD);
    ck(v,1,0,currVal_1,currVal_2,currVal_3);
    const currVal_4:any = 'Visa';
    ck(v,4,0,currVal_4);
    const currVal_5:any = 'Mastercard';
    ck(v,7,0,currVal_5);
    const currVal_6:any = 'Amex';
    ck(v,10,0,currVal_6);
    const currVal_7:any = (co.paymentModel.paymentProvider === co.IntegratedPaymentProvider.STRIPE);
    ck(v,13,0,currVal_7);
    const currVal_8:any = (co.paymentModel.paymentProvider === co.IntegratedPaymentProvider.TYRO);
    ck(v,16,0,currVal_8);
    const currVal_9:any = (co.paymentModel.paymentProvider === co.IntegratedPaymentProvider.OOLIO);
    ck(v,19,0,currVal_9);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    ck(v,0,0,currVal_0);
  });
}
function View_PaymentPageComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'woa-radio-field',([] as any[]),[[
        2,
        'disabled',
        (null as any)
      ]
      ],[[
        (null as any),
        'selectedChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('selectedChange' === en)) {
        const pd_0:any = ((<any>(co.paymentType = co.PaymentType.POINTS)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import17.View_RadioFieldComponent_0,import17.RenderType_RadioFieldComponent)),
    import0.ɵdid(1097728,(null as any),0,import18.RadioFieldComponent,[import0.ElementRef],{
      label: [
        0,
        'label'
      ]
      ,
      message: [
        1,
        'message'
      ]
      ,
      translationParams: [
        2,
        'translationParams'
      ]
      ,
      disabled: [
        3,
        'disabled'
      ]
      ,
      selected: [
        4,
        'selected'
      ]

    }
    ,{selectedChange: 'selectedChange'}),
    import0.ɵpod([
      'amount',
      'required',
      'balance'
    ]
    ),
    (l()(),import0.ɵted(0,['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),0,1,'woa-icon',([] as any[]),(null as any),(null as any),(null as any),import19.View_IconComponent_0,import19.RenderType_IconComponent)),
      import0.ɵdid(573440,(null as any),0,import20.IconComponent,[import0.ChangeDetectorRef],{name: [
        0,
        'name'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = (co.canPayWithPoints? 'woa.label.payment.payWithPoints': 'woa.label.payment.pointsRequired');
    const currVal_2:any = 'woa.message.payment.pointsBalance';
    const currVal_3:any = ck(v,2,0,((co.orderModel.initiatedOrder == null)? (null as any): co.orderModel.initiatedOrder.memberAvailableRedemptionPoints),((co.orderModel.initiatedOrder == null)? (null as any): co.orderModel.initiatedOrder.pointsRedeemable),((co.orderModel.initiatedOrder == null)? (null as any): co.orderModel.initiatedOrder.memberPointsBalance));
    const currVal_4:boolean = !co.canPayWithPoints;
    const currVal_5:any = (co.paymentType === co.PaymentType.POINTS);
    ck(v,1,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5);
    const currVal_6:any = 'star';
    ck(v,5,0,currVal_6);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    ck(v,0,0,currVal_0);
  });
}
function View_PaymentPageComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),21,'woa-field-group',[[
        'class',
        'order-placement-options'
      ]
    ],(null as any),(null as any),(null as any),import32.View_FieldGroupComponent_0,import32.RenderType_FieldGroupComponent)),
      import0.ɵdid(49152,(null as any),0,import33.FieldGroupComponent,([] as any[]),{title: [
        0,
        'title'
      ]
    },(null as any)),
    import0.ɵprd(5120,(null as any),import34.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import33.FieldGroupComponent]),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_PaymentPageComponent_6)),
    import0.ɵdid(802816,(null as any),0,import16.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_PaymentPageComponent_7)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_PaymentPageComponent_8)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_PaymentPageComponent_9)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_PaymentPageComponent_10)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_PaymentPageComponent_14)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'woa.heading.payment.paymentOptions';
    ck(v,1,0,currVal_0);
    const currVal_1:any = co.orderModel.initiatedOrder.availableTransferTargets;
    ck(v,5,0,currVal_1);
    const currVal_2:any = co.paymentModel.canMakeApplePayPayment;
    ck(v,8,0,currVal_2);
    const currVal_3:any = co.paymentModel.canMakeGooglePayPayment;
    ck(v,11,0,currVal_3);
    const currVal_4:any = co.showSavedCreditCardPayment;
    ck(v,14,0,currVal_4);
    const currVal_5:any = co.showNewCreditCardPayment;
    ck(v,17,0,currVal_5);
    const currVal_6:any = co.showPointsPayment;
    ck(v,20,0,currVal_6);
  },(null as any));
}
function View_PaymentPageComponent_16(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,[[
        5,
        0
      ]
      ],(null as any),4,'woa-stripe-scanned-payment-card-panel',([] as any[]),(null as any),[[
        (null as any),
        'onChangeCard'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onChangeCard' === en)) {
        const pd_0:any = ((<any>(co.scannedCard = (undefined as any))) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import35.View_StripeScannedPaymentCardPanelComponent_0,import35.RenderType_StripeScannedPaymentCardPanelComponent)),
    import0.ɵdid(180224,(null as any),0,import36.StripeScannedPaymentCardPanelComponent,[
      import0.ChangeDetectorRef,
      import13.ResponsiveService,
      import37.TranslateService,
      import0.ElementRef,
      import38.Http,
      import25.PaymentModel
    ]
    ,{
      disabled: [
        0,
        'disabled'
      ]
      ,
      cardNumber: [
        1,
        'cardNumber'
      ]
      ,
      cardExpiry: [
        2,
        'cardExpiry'
      ]

    }
    ,{onChangeCard: 'onChangeCard'}),
    import0.ɵpid(131072,import16.AsyncPipe,[import0.ChangeDetectorRef]),
      import0.ɵprd(2048,[[
        11,
        4
      ]
    ],import39.AbstractModelContainer,(null as any),[import36.StripeScannedPaymentCardPanelComponent]),
      import0.ɵprd(2048,[[
        6,
        4
      ]
    ],import26.PaymentCard,(null as any),[import36.StripeScannedPaymentCardPanelComponent])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:boolean = (!co.showCardDetails || (import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(co.OrderEvents.orderSubmissionStatus$)) === co.OrderSubmissionStatus.SUBMITTING));
    const currVal_1:any = co.scannedCard.formattedCardNumber;
    const currVal_2:any = co.scannedCard.expiry;
    ck(v,1,0,currVal_0,currVal_1,currVal_2);
  },(null as any));
}
function View_PaymentPageComponent_17(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,[[
        5,
        0
      ]
    ],(null as any),3,'woa-stripe-manual-payment-card-panel',([] as any[]),(null as any),(null as any),(null as any),import23.View_StripeManualPaymentCardPanelComponent_0,import23.RenderType_StripeManualPaymentCardPanelComponent)),
    import0.ɵdid(4964352,(null as any),0,import24.StripeManualPaymentCardPanelComponent,[
      import0.ElementRef,
      import8.SessionModel,
      import0.ChangeDetectorRef,
      import13.ResponsiveService,
      import25.PaymentModel
    ]
      ,{disabled: [
        0,
        'disabled'
      ]
    },(null as any)),
    import0.ɵpid(131072,import16.AsyncPipe,[import0.ChangeDetectorRef]),
      import0.ɵprd(2048,[[
        6,
        4
      ]
    ],import26.PaymentCard,(null as any),[import24.StripeManualPaymentCardPanelComponent])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:boolean = (!co.showCardDetails || (import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(co.OrderEvents.orderSubmissionStatus$)) === co.OrderSubmissionStatus.SUBMITTING));
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_PaymentPageComponent_18(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,[[
        5,
        0
      ]
      ],(null as any),3,'woa-tyro-manual-payment-card-panel',([] as any[]),[[
        2,
        'disabled',
        (null as any)
      ]
    ],(null as any),(null as any),import27.View_TyroManualPaymentCardPanelComponent_0,import27.RenderType_TyroManualPaymentCardPanelComponent)),
    import0.ɵdid(4964352,(null as any),0,import28.TyroManualPaymentCardPanelComponent,[
      import0.ElementRef,
      import8.SessionModel,
      import0.ChangeDetectorRef,
      import13.ResponsiveService,
      import25.PaymentModel,
      import29.ThemeModel
    ]
      ,{disabled: [
        0,
        'disabled'
      ]
    },(null as any)),
    import0.ɵpid(131072,import16.AsyncPipe,[import0.ChangeDetectorRef]),
      import0.ɵprd(2048,[[
        6,
        4
      ]
    ],import26.PaymentCard,(null as any),[import28.TyroManualPaymentCardPanelComponent])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:boolean = (!co.showCardDetails || (import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(co.OrderEvents.orderSubmissionStatus$)) === co.OrderSubmissionStatus.SUBMITTING));
    ck(v,1,0,currVal_1);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    ck(v,0,0,currVal_0);
  });
}
function View_PaymentPageComponent_15(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),14,'woa-field-group',[[
        'class',
        'order-placement-card-details'
      ]
      ],(null as any),[[
        (null as any),
        'onActivateTitle'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivateTitle' === en)) {
        const pd_0:any = ((<any>co.copyDefaultCardNr()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import32.View_FieldGroupComponent_0,import32.RenderType_FieldGroupComponent)),
      import0.ɵdid(49152,(null as any),0,import33.FieldGroupComponent,([] as any[]),{title: [
        0,
        'title'
      ]
    },{onActivateTitle: 'onActivateTitle'}),
    import0.ɵprd(5120,(null as any),import34.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import33.FieldGroupComponent]),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_PaymentPageComponent_16)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_PaymentPageComponent_17)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_PaymentPageComponent_18)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'woa.heading.payment.cardDetails';
    ck(v,1,0,currVal_0);
    const currVal_1:any = co.scannedCard;
    ck(v,5,0,currVal_1);
    const currVal_2:boolean = (!co.scannedCard && (co.paymentModel.paymentProvider === co.IntegratedPaymentProvider.STRIPE));
    ck(v,9,0,currVal_2);
    const currVal_3:boolean = (!co.scannedCard && (co.paymentModel.paymentProvider === co.IntegratedPaymentProvider.TYRO));
    ck(v,13,0,currVal_3);
  },(null as any));
}
function View_PaymentPageComponent_20(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'woa-phone-number-field',[
      [
        'name',
        'mobilePhone'
      ]
      ,
      [
        'woa-phone-number',
        ''
      ]

    ]
    ,[
      [
        1,
        'required',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'ngModelChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.mobilePhone = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import40.View_PhoneNumberFieldComponent_0,import40.RenderType_PhoneNumberFieldComponent)),
      import0.ɵdid(16384,(null as any),0,import34.RequiredValidator,([] as any[]),{required: [
        0,
        'required'
      ]
    },(null as any)),
    import0.ɵdid(16384,(null as any),0,import41.PhoneNumberDirective,([] as any[]),(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import34.NG_VALIDATORS,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import34.RequiredValidator,
      import41.PhoneNumberDirective
    ]
    ),
      import0.ɵdid(180224,(null as any),0,import42.PhoneNumberFieldComponent,[import0.ChangeDetectorRef],{label: [
        0,
        'label'
      ]
    },(null as any)),
    import0.ɵprd(1024,(null as any),import34.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import42.PhoneNumberFieldComponent]),
      import0.ɵdid(671744,[[
        10,
        4
      ]
    ],0,import34.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import34.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import34.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import34.NgControl,(null as any),[import34.NgModel]),
    import0.ɵdid(16384,(null as any),0,import34.NgControlStatus,[import34.NgControl],(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.orderingContextModel.requirePhoneNumber;
    ck(v,1,0,currVal_8);
    const currVal_9:any = 'woa.label.common.mobile';
    ck(v,4,0,currVal_9);
    const currVal_10:any = 'mobilePhone';
    const currVal_11:any = co.mobilePhone;
    ck(v,6,0,currVal_10,currVal_11);
  },(ck,v) => {
    const currVal_0:any = (import0.ɵnov(v,1).required? '': (null as any));
    const currVal_1:any = import0.ɵnov(v,8).ngClassUntouched;
    const currVal_2:any = import0.ɵnov(v,8).ngClassTouched;
    const currVal_3:any = import0.ɵnov(v,8).ngClassPristine;
    const currVal_4:any = import0.ɵnov(v,8).ngClassDirty;
    const currVal_5:any = import0.ɵnov(v,8).ngClassValid;
    const currVal_6:any = import0.ɵnov(v,8).ngClassInvalid;
    const currVal_7:any = import0.ɵnov(v,8).ngClassPending;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_PaymentPageComponent_19(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,[[
        3,
        0
      ]
    ],(null as any),15,'woa-field-group',([] as any[]),(null as any),(null as any),(null as any),import32.View_FieldGroupComponent_0,import32.RenderType_FieldGroupComponent)),
      import0.ɵdid(49152,[[
        'deliveryDetails',
        4
      ]
      ],0,import33.FieldGroupComponent,([] as any[]),{title: [
        0,
        'title'
      ]
    },(null as any)),
    import0.ɵprd(5120,(null as any),import34.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import33.FieldGroupComponent]),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_PaymentPageComponent_20)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),0,7,'woa-text-area-field',[[
        'name',
        'deliveryInstructions'
      ]
    ],[
      [
        1,
        'maxlength',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'ngModelChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.orderingContextModel.deliveryInstructions = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import43.View_TextAreaFieldComponent_0,import43.RenderType_TextAreaFieldComponent)),
      import0.ɵdid(540672,(null as any),0,import34.MaxLengthValidator,([] as any[]),{maxlength: [
        0,
        'maxlength'
      ]
    },(null as any)),
    import0.ɵprd(1024,(null as any),import34.NG_VALIDATORS,(p0_0:any) => {
      return [p0_0];
    },[import34.MaxLengthValidator]),
      import0.ɵdid(180224,(null as any),0,import44.TextAreaFieldComponent,[import0.ChangeDetectorRef],{label: [
        0,
        'label'
      ]
    },(null as any)),
    import0.ɵprd(1024,(null as any),import34.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import44.TextAreaFieldComponent]),
      import0.ɵdid(671744,[[
        10,
        4
      ]
    ],0,import34.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import34.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import34.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import34.NgControl,(null as any),[import34.NgModel]),
    import0.ɵdid(16384,(null as any),0,import34.NgControlStatus,[import34.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'woa.heading.payment.deliveryDetails';
    ck(v,1,0,currVal_0);
    const currVal_1:any = co.showPhoneNumberField;
    ck(v,5,0,currVal_1);
    const currVal_10:any = '255';
    ck(v,8,0,currVal_10);
    const currVal_11:any = 'woa.label.address.deliveryInstructions';
    ck(v,10,0,currVal_11);
    const currVal_12:any = 'deliveryInstructions';
    const currVal_13:any = co.orderingContextModel.deliveryInstructions;
    ck(v,12,0,currVal_12,currVal_13);
  },(ck,v) => {
    const currVal_2:any = (import0.ɵnov(v,8).maxlength? import0.ɵnov(v,8).maxlength: (null as any));
    const currVal_3:any = import0.ɵnov(v,14).ngClassUntouched;
    const currVal_4:any = import0.ɵnov(v,14).ngClassTouched;
    const currVal_5:any = import0.ɵnov(v,14).ngClassPristine;
    const currVal_6:any = import0.ɵnov(v,14).ngClassDirty;
    const currVal_7:any = import0.ɵnov(v,14).ngClassValid;
    const currVal_8:any = import0.ɵnov(v,14).ngClassInvalid;
    const currVal_9:any = import0.ɵnov(v,14).ngClassPending;
    ck(v,7,0,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9);
  });
}
function View_PaymentPageComponent_22(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),23,'woa-field-pair',([] as any[]),(null as any),(null as any),(null as any),import45.View_FieldPairComponent_0,import45.RenderType_FieldPairComponent)),
    import0.ɵdid(49152,(null as any),0,import46.FieldPairComponent,([] as any[]),(null as any),(null as any)),
    import0.ɵprd(5120,(null as any),import34.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import46.FieldPairComponent]),
    (l()(),import0.ɵted(0,['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),0,8,'woa-text-field',[[
        'name',
        'firstName'
      ]
    ],[
      [
        1,
        'required',
        0
      ]
      ,
      [
        1,
        'maxlength',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'ngModelChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.firstName = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import47.View_TextFieldComponent_0,import47.RenderType_TextFieldComponent)),
      import0.ɵdid(16384,(null as any),0,import34.RequiredValidator,([] as any[]),{required: [
        0,
        'required'
      ]
    },(null as any)),
      import0.ɵdid(540672,(null as any),0,import34.MaxLengthValidator,([] as any[]),{maxlength: [
        0,
        'maxlength'
      ]
    },(null as any)),
    import0.ɵprd(1024,(null as any),import34.NG_VALIDATORS,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import34.RequiredValidator,
      import34.MaxLengthValidator
    ]
    ),
    import0.ɵdid(180224,(null as any),0,import48.TextFieldComponent,[import0.ChangeDetectorRef],{
      label: [
        0,
        'label'
      ]
      ,
      autocomplete: [
        1,
        'autocomplete'
      ]
      ,
      maxlength: [
        2,
        'maxlength'
      ]
      ,
      spellcheck: [
        3,
        'spellcheck'
      ]

    }
    ,(null as any)),
    import0.ɵprd(1024,(null as any),import34.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import48.TextFieldComponent]),
      import0.ɵdid(671744,[[
        10,
        4
      ]
    ],0,import34.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import34.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import34.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import34.NgControl,(null as any),[import34.NgModel]),
    import0.ɵdid(16384,(null as any),0,import34.NgControlStatus,[import34.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),0,8,'woa-text-field',[[
        'name',
        'lastName'
      ]
    ],[
      [
        1,
        'required',
        0
      ]
      ,
      [
        1,
        'maxlength',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'ngModelChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.lastName = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import47.View_TextFieldComponent_0,import47.RenderType_TextFieldComponent)),
      import0.ɵdid(16384,(null as any),0,import34.RequiredValidator,([] as any[]),{required: [
        0,
        'required'
      ]
    },(null as any)),
      import0.ɵdid(540672,(null as any),0,import34.MaxLengthValidator,([] as any[]),{maxlength: [
        0,
        'maxlength'
      ]
    },(null as any)),
    import0.ɵprd(1024,(null as any),import34.NG_VALIDATORS,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import34.RequiredValidator,
      import34.MaxLengthValidator
    ]
    ),
    import0.ɵdid(180224,(null as any),0,import48.TextFieldComponent,[import0.ChangeDetectorRef],{
      label: [
        0,
        'label'
      ]
      ,
      autocomplete: [
        1,
        'autocomplete'
      ]
      ,
      maxlength: [
        2,
        'maxlength'
      ]
      ,
      spellcheck: [
        3,
        'spellcheck'
      ]

    }
    ,(null as any)),
    import0.ɵprd(1024,(null as any),import34.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import48.TextFieldComponent]),
      import0.ɵdid(671744,[[
        10,
        4
      ]
    ],0,import34.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import34.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import34.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import34.NgControl,(null as any),[import34.NgModel]),
    import0.ɵdid(16384,(null as any),0,import34.NgControlStatus,[import34.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_9:any = co.requireFirstName;
    ck(v,5,0,currVal_9);
    const currVal_10:any = '30';
    ck(v,6,0,currVal_10);
    const currVal_11:any = 'woa.label.common.firstName';
    const currVal_12:any = 'given-name';
    const currVal_13:any = '30';
    const currVal_14:any = false;
    ck(v,8,0,currVal_11,currVal_12,currVal_13,currVal_14);
    const currVal_15:any = 'firstName';
    const currVal_16:any = co.firstName;
    ck(v,10,0,currVal_15,currVal_16);
    const currVal_26:any = co.requireLastName;
    ck(v,15,0,currVal_26);
    const currVal_27:any = '30';
    ck(v,16,0,currVal_27);
    const currVal_28:any = 'woa.label.common.lastName';
    const currVal_29:any = 'family-name';
    const currVal_30:any = '30';
    const currVal_31:any = false;
    ck(v,18,0,currVal_28,currVal_29,currVal_30,currVal_31);
    const currVal_32:any = 'lastName';
    const currVal_33:any = co.lastName;
    ck(v,20,0,currVal_32,currVal_33);
  },(ck,v) => {
    const currVal_0:any = (import0.ɵnov(v,5).required? '': (null as any));
    const currVal_1:any = (import0.ɵnov(v,6).maxlength? import0.ɵnov(v,6).maxlength: (null as any));
    const currVal_2:any = import0.ɵnov(v,12).ngClassUntouched;
    const currVal_3:any = import0.ɵnov(v,12).ngClassTouched;
    const currVal_4:any = import0.ɵnov(v,12).ngClassPristine;
    const currVal_5:any = import0.ɵnov(v,12).ngClassDirty;
    const currVal_6:any = import0.ɵnov(v,12).ngClassValid;
    const currVal_7:any = import0.ɵnov(v,12).ngClassInvalid;
    const currVal_8:any = import0.ɵnov(v,12).ngClassPending;
    ck(v,4,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8);
    const currVal_17:any = (import0.ɵnov(v,15).required? '': (null as any));
    const currVal_18:any = (import0.ɵnov(v,16).maxlength? import0.ɵnov(v,16).maxlength: (null as any));
    const currVal_19:any = import0.ɵnov(v,22).ngClassUntouched;
    const currVal_20:any = import0.ɵnov(v,22).ngClassTouched;
    const currVal_21:any = import0.ɵnov(v,22).ngClassPristine;
    const currVal_22:any = import0.ɵnov(v,22).ngClassDirty;
    const currVal_23:any = import0.ɵnov(v,22).ngClassValid;
    const currVal_24:any = import0.ɵnov(v,22).ngClassInvalid;
    const currVal_25:any = import0.ɵnov(v,22).ngClassPending;
    ck(v,14,0,currVal_17,currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,currVal_24,currVal_25);
  });
}
function View_PaymentPageComponent_23(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'woa-email-field',[
      [
        'name',
        'email'
      ]
      ,
      [
        'woa-email',
        ''
      ]

    ]
    ,[
      [
        1,
        'required',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'ngModelChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.email = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import49.View_EmailFieldComponent_0,import49.RenderType_EmailFieldComponent)),
      import0.ɵdid(16384,(null as any),0,import34.RequiredValidator,([] as any[]),{required: [
        0,
        'required'
      ]
    },(null as any)),
    import0.ɵdid(16384,(null as any),0,import50.EmailDirective,([] as any[]),(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import34.NG_VALIDATORS,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import34.RequiredValidator,
      import50.EmailDirective
    ]
    ),
      import0.ɵdid(180224,(null as any),0,import51.EmailFieldComponent,[import0.ChangeDetectorRef],{label: [
        0,
        'label'
      ]
    },(null as any)),
    import0.ɵprd(1024,(null as any),import34.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import51.EmailFieldComponent]),
      import0.ɵdid(671744,[[
        10,
        4
      ]
    ],0,import34.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import34.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import34.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import34.NgControl,(null as any),[import34.NgModel]),
    import0.ɵdid(16384,(null as any),0,import34.NgControlStatus,[import34.NgControl],(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.requireEmail;
    ck(v,1,0,currVal_8);
    const currVal_9:any = co.emailLabel;
    ck(v,4,0,currVal_9);
    const currVal_10:any = 'email';
    const currVal_11:any = co.email;
    ck(v,6,0,currVal_10,currVal_11);
  },(ck,v) => {
    const currVal_0:any = (import0.ɵnov(v,1).required? '': (null as any));
    const currVal_1:any = import0.ɵnov(v,8).ngClassUntouched;
    const currVal_2:any = import0.ɵnov(v,8).ngClassTouched;
    const currVal_3:any = import0.ɵnov(v,8).ngClassPristine;
    const currVal_4:any = import0.ɵnov(v,8).ngClassDirty;
    const currVal_5:any = import0.ɵnov(v,8).ngClassValid;
    const currVal_6:any = import0.ɵnov(v,8).ngClassInvalid;
    const currVal_7:any = import0.ɵnov(v,8).ngClassPending;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_PaymentPageComponent_24(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'woa-phone-number-field',[
      [
        'name',
        'mobilePhone'
      ]
      ,
      [
        'woa-phone-number',
        ''
      ]

    ]
    ,[
      [
        1,
        'required',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'ngModelChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.mobilePhone = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import40.View_PhoneNumberFieldComponent_0,import40.RenderType_PhoneNumberFieldComponent)),
      import0.ɵdid(16384,(null as any),0,import34.RequiredValidator,([] as any[]),{required: [
        0,
        'required'
      ]
    },(null as any)),
    import0.ɵdid(16384,(null as any),0,import41.PhoneNumberDirective,([] as any[]),(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import34.NG_VALIDATORS,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import34.RequiredValidator,
      import41.PhoneNumberDirective
    ]
    ),
      import0.ɵdid(180224,(null as any),0,import42.PhoneNumberFieldComponent,[import0.ChangeDetectorRef],{label: [
        0,
        'label'
      ]
    },(null as any)),
    import0.ɵprd(1024,(null as any),import34.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import42.PhoneNumberFieldComponent]),
      import0.ɵdid(671744,[[
        10,
        4
      ]
    ],0,import34.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import34.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import34.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import34.NgControl,(null as any),[import34.NgModel]),
    import0.ɵdid(16384,(null as any),0,import34.NgControlStatus,[import34.NgControl],(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.requirePhoneNumber;
    ck(v,1,0,currVal_8);
    const currVal_9:any = 'woa.label.common.mobile';
    ck(v,4,0,currVal_9);
    const currVal_10:any = 'mobilePhone';
    const currVal_11:any = co.mobilePhone;
    ck(v,6,0,currVal_10,currVal_11);
  },(ck,v) => {
    const currVal_0:any = (import0.ɵnov(v,1).required? '': (null as any));
    const currVal_1:any = import0.ɵnov(v,8).ngClassUntouched;
    const currVal_2:any = import0.ɵnov(v,8).ngClassTouched;
    const currVal_3:any = import0.ɵnov(v,8).ngClassPristine;
    const currVal_4:any = import0.ɵnov(v,8).ngClassDirty;
    const currVal_5:any = import0.ɵnov(v,8).ngClassValid;
    const currVal_6:any = import0.ɵnov(v,8).ngClassInvalid;
    const currVal_7:any = import0.ɵnov(v,8).ngClassPending;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_PaymentPageComponent_25(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-selector-control',[[
        'class',
        'order-placement-customer-details-marketing'
      ]
    ],[
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'touched',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'selectedChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('selectedChange' === en)) {
        const pd_0:any = ((<any>(co.orderingContextModel.marketingOptIn = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import52.View_SelectorControlComponent_0,import52.RenderType_SelectorControlComponent)),
    import0.ɵdid(49152,(null as any),0,import53.SelectorControlComponent,([] as any[]),{
      selected: [
        0,
        'selected'
      ]
      ,
      label: [
        1,
        'label'
      ]

    }
    ,{selectedChange: 'selectedChange'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = co.orderingContextModel.marketingOptIn;
    const currVal_3:any = 'woa.label.common.marketingOptIn';
    ck(v,1,0,currVal_2,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    const currVal_1:any = import0.ɵnov(v,1).touched;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
function View_PaymentPageComponent_21(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,[[
        4,
        0
      ]
      ],(null as any),15,'woa-field-group',[[
        'class',
        'order-placement-customer-details'
      ]
    ],(null as any),(null as any),(null as any),import32.View_FieldGroupComponent_0,import32.RenderType_FieldGroupComponent)),
      import0.ɵdid(49152,[[
        'customerDetails',
        4
      ]
      ],0,import33.FieldGroupComponent,([] as any[]),{title: [
        0,
        'title'
      ]
    },(null as any)),
    import0.ɵprd(5120,(null as any),import34.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import33.FieldGroupComponent]),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_PaymentPageComponent_22)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_PaymentPageComponent_23)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_PaymentPageComponent_24)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_PaymentPageComponent_25)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'woa.heading.payment.customerDetails';
    ck(v,1,0,currVal_0);
    const currVal_1:any = co.showNameField;
    ck(v,5,0,currVal_1);
    const currVal_2:any = co.showEmailField;
    ck(v,8,0,currVal_2);
    const currVal_3:any = (co.showPhoneNumberField && !co.orderingContextModel.isConfirmedDeliveryOrdering);
    ck(v,11,0,currVal_3);
    const currVal_4:any = co.orderingContextModel.showMarketingOptIn;
    ck(v,14,0,currVal_4);
  },(null as any));
}
function View_PaymentPageComponent_26(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-tip-selection-panel',[[
        'class',
        'order-placement-tip'
      ]
    ],(null as any),[
      [
        (null as any),
        'tipAmountChange'
      ]
      ,
      [
        (null as any),
        'tipSelectedChange'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('tipAmountChange' === en)) {
        const pd_0:any = ((<any>(co.orderModel.tipAmount = $event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('tipSelectedChange' === en)) {
        const pd_1:any = ((<any>(co.orderingContextModel.tipSelected = $event)) !== false);
        ad = (pd_1 && ad);
      }
      if (('tipAmountChange' === en)) {
        const pd_2:any = ((<any>co.tipChanged()) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },import54.View_TipSelectionPanelComponent_0,import54.RenderType_TipSelectionPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import55.TipSelectionPanelComponent,[
      import9.OrderingContextModel,
      import10.OrderModel
    ]
    ,{
      tipAmount: [
        0,
        'tipAmount'
      ]
      ,
      tipSelected: [
        1,
        'tipSelected'
      ]
      ,
      showTipInstructions: [
        2,
        'showTipInstructions'
      ]

    }
    ,{
      tipAmountChange: 'tipAmountChange',
      tipSelectedChange: 'tipSelectedChange'
    }
    )
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.orderModel.tipAmount;
    const currVal_1:any = co.orderingContextModel.tipSelected;
    const currVal_2:any = true;
    ck(v,1,0,currVal_0,currVal_1,currVal_2);
  },(null as any));
}
function View_PaymentPageComponent_27(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-button',[
      [
        'id',
        'no-pay-button'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.form.submit()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import56.View_ButtonComponent_0,import56.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import57.ButtonComponent,[
      import0.ElementRef,
      import8.SessionModel,
      import0.ChangeDetectorRef,
      import13.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      disabled: [
        1,
        'disabled'
      ]

    }
    ,(null as any)),
      import0.ɵdid(16384,[[
        7,
        4
      ]
    ],0,import58.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = 'woa.button.payment.placeOrder';
    const currVal_28:any = co.sessionModel.timeTestMode;
    ck(v,1,0,currVal_27,currVal_28);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_PaymentPageComponent_28(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-button',[
      [
        'id',
        'waiter-pay-button'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.form.submit()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import56.View_ButtonComponent_0,import56.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import57.ButtonComponent,[
      import0.ElementRef,
      import8.SessionModel,
      import0.ChangeDetectorRef,
      import13.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      disabled: [
        1,
        'disabled'
      ]

    }
    ,(null as any)),
      import0.ɵdid(16384,[[
        7,
        4
      ]
    ],0,import58.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = 'woa.button.payment.placeOrder';
    const currVal_28:any = co.sessionModel.timeTestMode;
    ck(v,1,0,currVal_27,currVal_28);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_PaymentPageComponent_29(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-button',[
      [
        'id',
        'group-pay-button'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.form.submit()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import56.View_ButtonComponent_0,import56.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import57.ButtonComponent,[
      import0.ElementRef,
      import8.SessionModel,
      import0.ChangeDetectorRef,
      import13.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      disabled: [
        1,
        'disabled'
      ]

    }
    ,(null as any)),
      import0.ɵdid(16384,[[
        7,
        4
      ]
    ],0,import58.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = 'woa.button.payment.payWithGroupOrder';
    const currVal_28:any = co.sessionModel.timeTestMode;
    ck(v,1,0,currVal_27,currVal_28);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_PaymentPageComponent_30(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-apple-pay-button',[
      [
        'id',
        'apple-pay-button'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'pay'
      ]
      ,
      [
        (null as any),
        'click'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('pay' === en)) {
        const pd_1:any = ((<any>co.form.submit()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import59.View_ApplePayButtonComponent_0,import59.RenderType_ApplePayButtonComponent)),
    import0.ɵdid(4964352,(null as any),0,import60.ApplePayButtonComponent,[
      import0.ElementRef,
      import25.PaymentModel,
      import0.ChangeDetectorRef
    ]
    ,{
      passiveOnly: [
        0,
        'passiveOnly'
      ]
      ,
      type: [
        1,
        'type'
      ]
      ,
      disabled: [
        2,
        'disabled'
      ]

    }
    ,{pay: 'pay'}),
      import0.ɵdid(16384,[[
        7,
        4
      ]
    ],0,import58.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = true;
    const currVal_3:any = (co.paymentModel.walletPaymentProcessor.canSubmit? 'plain': 'check-out');
    const currVal_4:any = co.sessionModel.timeTestMode;
    ck(v,1,0,currVal_2,currVal_3,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    const currVal_1:any = import0.ɵnov(v,1).button;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
function View_PaymentPageComponent_31(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-google-pay-button',[
      [
        'id',
        'google-pay-button'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'pay'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('pay' === en)) {
        const pd_0:any = ((<any>co.form.submit()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import61.View_GooglePayButtonComponent_0,import61.RenderType_GooglePayButtonComponent)),
    import0.ɵdid(4898816,(null as any),0,import62.GooglePayButtonComponent,[
      import0.ElementRef,
      import25.PaymentModel,
      import0.ChangeDetectorRef,
      import8.SessionModel
    ]
    ,{
      passive: [
        0,
        'passive'
      ]
      ,
      type: [
        1,
        'type'
      ]
      ,
      disabled: [
        2,
        'disabled'
      ]

    }
    ,{pay: 'pay'}),
      import0.ɵdid(16384,[[
        7,
        4
      ]
    ],0,import58.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = true;
    const currVal_3:any = (co.paymentModel.walletPaymentProcessor.canSubmit? 'plain': 'checkout');
    const currVal_4:any = co.sessionModel.timeTestMode;
    ck(v,1,0,currVal_2,currVal_3,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    const currVal_1:any = import0.ɵnov(v,1).button;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
function View_PaymentPageComponent_32(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'woa-button',[
      [
        'id',
        'credit-card-pay-button'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.form.submit()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import56.View_ButtonComponent_0,import56.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import57.ButtonComponent,[
      import0.ElementRef,
      import8.SessionModel,
      import0.ChangeDetectorRef,
      import13.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      translationParams: [
        1,
        'translationParams'
      ]
      ,
      disabled: [
        2,
        'disabled'
      ]

    }
    ,(null as any)),
    import0.ɵppd(2),
    import0.ɵpod(['amount']),
      import0.ɵdid(16384,[[
        7,
        4
      ]
    ],0,import58.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = 'woa.button.payment.payWithCard';
    const currVal_28:any = ck(v,3,0,import0.ɵunv(v,1,1,ck(v,2,0,import0.ɵnov((<any>v.parent),1),co.orderModel.orderTotalPayment,'AU$')));
    const currVal_29:any = co.sessionModel.timeTestMode;
    ck(v,1,0,currVal_27,currVal_28,currVal_29);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_PaymentPageComponent_33(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-button',[
      [
        'id',
        'points-pay-button'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.form.submit()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import56.View_ButtonComponent_0,import56.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import57.ButtonComponent,[
      import0.ElementRef,
      import8.SessionModel,
      import0.ChangeDetectorRef,
      import13.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      translationParams: [
        1,
        'translationParams'
      ]
      ,
      disabled: [
        2,
        'disabled'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['amount']),
      import0.ɵdid(16384,[[
        7,
        4
      ]
    ],0,import58.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = 'woa.button.payment.payWithPoints';
    const currVal_28:any = ck(v,2,0,((co.orderModel.initiatedOrder == null)? (null as any): co.orderModel.initiatedOrder.memberAvailableRedemptionPoints));
    const currVal_29:any = co.sessionModel.timeTestMode;
    ck(v,1,0,currVal_27,currVal_28,currVal_29);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
export function View_PaymentPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import63.PossessivePipe,([] as any[])),
    import0.ɵpid(0,import64.CurrencyPipe,([] as any[])),
    import0.ɵqud(402653184,1,{pageLayout: 0}),
    import0.ɵqud(402653184,2,{form: 0}),
    import0.ɵqud(671088640,3,{deliveryDetailsER: 0}),
    import0.ɵqud(671088640,4,{customerDetailsER: 0}),
    import0.ɵqud(671088640,5,{paymentCardER: 0}),
    import0.ɵqud(671088640,6,{paymentCard: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),64,'woa-full-page-layout',([] as any[]),(null as any),(null as any),(null as any),import65.View_FullPageLayoutComponent_0,import65.RenderType_FullPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),1,import66.FullPageLayoutComponent,[
      import67.Page,
      import11.NavigationService,
      import13.ResponsiveService,
      import29.ThemeModel
    ]
    ,{
      showNavbarLogo: [
        0,
        'showNavbarLogo'
      ]
      ,
      pillarboxedOnDesktop: [
        1,
        'pillarboxedOnDesktop'
      ]
      ,
      showContent: [
        2,
        'showContent'
      ]
      ,
      showFooter: [
        3,
        'showFooter'
      ]
      ,
      showFooterShadow: [
        4,
        'showFooterShadow'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,7,{footerControls: 1}),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import67.PageLayout,(null as any),[import66.FullPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),2,1,(null as any),View_PaymentPageComponent_1)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),3,2,(null as any),View_PaymentPageComponent_2)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import16.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),5,1,(null as any),View_PaymentPageComponent_3)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),5,21,'woa-form',[
      [
        'class',
        'order-placement'
      ]
      ,
      [
        'slot',
        'content-right'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'onSubmit'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import68.PaymentPageComponent = v.component;
      if (('onSubmit' === en)) {
        const pd_0:any = ((<any>co.placeOrder()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import69.View_FormComponent_0,import69.RenderType_FormComponent)),
      import0.ɵdid(1097728,[[
        2,
        4
      ]
    ],2,import39.FormComponent,[import3.NotificationService],(null as any),{onSubmit: 'onSubmit'}),
    import0.ɵqud(603979776,10,{models: 1}),
    import0.ɵqud(603979776,11,{modelContainers: 1}),
    import0.ɵdid(737280,(null as any),0,import12.ResponsiveDirective,[
      import0.ElementRef,
      import13.ResponsiveService,
      import11.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(5120,(null as any),import39.FORM_CONTROL,(p0_0:any) => {
      return [p0_0];
    },[import39.FormComponent]),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_PaymentPageComponent_5)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_PaymentPageComponent_15)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_PaymentPageComponent_19)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_PaymentPageComponent_21)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_PaymentPageComponent_26)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),7,1,'woa-order-totals-panel',[
      [
        'class',
        'payment-totals'
      ]
      ,
      [
        'slot',
        'footer-start'
      ]

    ]
    ,(null as any),(null as any),(null as any),import70.View_OrderTotalsPanelComponent_0,import70.RenderType_OrderTotalsPanelComponent)),
    import0.ɵdid(180224,(null as any),0,import71.OrderTotalsPanelComponent,[
      import9.OrderingContextModel,
      import10.OrderModel,
      import11.NavigationService,
      import0.ChangeDetectorRef
    ]
      ,{totalOnly: [
        0,
        'totalOnly'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),8,1,(null as any),View_PaymentPageComponent_27)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),8,1,(null as any),View_PaymentPageComponent_28)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),8,1,(null as any),View_PaymentPageComponent_29)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),8,1,(null as any),View_PaymentPageComponent_30)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),8,1,(null as any),View_PaymentPageComponent_31)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),8,1,(null as any),View_PaymentPageComponent_32)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),8,1,(null as any),View_PaymentPageComponent_33)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),9,1,'woa-legal-panel',[
      [
        'class',
        'payment-legal'
      ]
      ,
      [
        'slot',
        'footer-end'
      ]

    ]
    ,(null as any),(null as any),(null as any),import72.View_LegalPanelComponent_0,import72.RenderType_LegalPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import73.LegalPanelComponent,[
      import74.AnalyticsService,
      import11.NavigationService
    ]
      ,{messageSet: [
        0,
        'messageSet'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import68.PaymentPageComponent = v.component;
    const currVal_0:any = true;
    const currVal_1:any = 'double-mobile';
    const currVal_2:any = (co.loadingStatus === co.LoadingStatus.LOADED);
    const currVal_3:any = co.showFooter;
    const currVal_4:any = true;
    ck(v,9,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4);
    const currVal_5:any = (co.loadingStatus === co.LoadingStatus.FAILED);
    ck(v,14,0,currVal_5);
    const currVal_6:any = import0.ɵunv(v,17,0,import0.ɵnov(v,18).transform(co.responsiveService.desktop$));
    ck(v,17,0,currVal_6);
    const currVal_7:boolean = !co.orderingContextModel.isConfirmedTableOrdering;
    ck(v,21,0,currVal_7);
    ck(v,27,0);
    const currVal_8:any = (co.orderModel.paymentRequired && !co.sessionModel.waiterMode);
    ck(v,31,0,currVal_8);
    const currVal_9:any = (co.orderModel.paymentRequired && co.sessionModel.waiterMode);
    ck(v,34,0,currVal_9);
    const currVal_10:any = co.orderingContextModel.isConfirmedDeliveryOrdering;
    ck(v,37,0,currVal_10);
    const currVal_11:any = co.showCustomerDetails;
    ck(v,40,0,currVal_11);
    const currVal_12:any = co.showTips;
    ck(v,43,0,currVal_12);
    const currVal_13:any = true;
    ck(v,47,0,currVal_13);
    const currVal_14:any = (co.paymentType === co.PaymentType.NONE);
    ck(v,50,0,currVal_14);
    const currVal_15:any = co.sessionModel.waiterMode;
    ck(v,53,0,currVal_15);
    const currVal_16:any = (co.paymentType === co.PaymentType.GROUP_PAY);
    ck(v,56,0,currVal_16);
    const currVal_17:any = (co.paymentType === co.PaymentType.APPLE_PAY);
    ck(v,59,0,currVal_17);
    const currVal_18:any = (co.paymentType === co.PaymentType.GOOGLE_PAY);
    ck(v,62,0,currVal_18);
    const currVal_19:any = ((co.paymentType === co.PaymentType.SAVED_CREDIT_CARD) || (co.paymentType === co.PaymentType.NEW_CREDIT_CARD));
    ck(v,65,0,currVal_19);
    const currVal_20:any = (co.paymentType === co.PaymentType.POINTS);
    ck(v,68,0,currVal_20);
    const currVal_21:any = 'payment';
    ck(v,71,0,currVal_21);
  },(null as any));
}
function View_PaymentPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-payment-page',([] as any[]),(null as any),(null as any),(null as any),View_PaymentPageComponent_0,RenderType_PaymentPageComponent)),
    import0.ɵdid(245760,(null as any),0,import68.PaymentPageComponent,[
      import75.NavigationParams,
      import76.SessionController,
      import77.GroupOrderModel,
      import78.IdentityModel,
      import11.NavigationService,
      import0.ChangeDetectorRef,
      import79.LoadingService,
      import80.LocalConfigurationService,
      import81.CardScanService,
      import8.SessionModel,
      import9.OrderingContextModel,
      import13.ResponsiveService,
      import10.OrderModel,
      import25.PaymentModel,
      import82.CustomerDetailsService
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import67.Page,(null as any),[import68.PaymentPageComponent])
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const PaymentPageComponentNgFactory:import0.ComponentFactory<import68.PaymentPageComponent> = import0.ɵccf('woa-payment-page',import68.PaymentPageComponent,View_PaymentPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvcGF5bWVudC9wYXltZW50LXBhZ2UvcGF5bWVudC1wYWdlLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9zcmMvYXBwL3BheW1lbnQvcGF5bWVudC1wYWdlL3BheW1lbnQtcGFnZS5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9zcmMvYXBwL3BheW1lbnQvcGF5bWVudC1wYWdlL3BheW1lbnQtcGFnZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvcGF5bWVudC9wYXltZW50LXBhZ2UvcGF5bWVudC1wYWdlLmNvbXBvbmVudC50cy5QYXltZW50UGFnZUNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjx3b2EtZnVsbC1wYWdlLWxheW91dCBbcGlsbGFyYm94ZWRPbkRlc2t0b3BdPVwiJ2RvdWJsZS1tb2JpbGUnXCJcbiAgICAgICAgICAgICAgICAgICAgICBbc2hvd0NvbnRlbnRdPVwibG9hZGluZ1N0YXR1cyA9PT0gTG9hZGluZ1N0YXR1cy5MT0FERURcIiBbc2hvd05hdmJhckxvZ29dPVwidHJ1ZVwiXG4gICAgICAgICAgICAgICAgICAgICAgW3Nob3dGb290ZXJdPVwic2hvd0Zvb3RlclwiIFtzaG93Rm9vdGVyU2hhZG93XT1cInRydWVcIj5cbiAgICA8d29hLWNvbnRlbnQtbWVzc2FnZSAqbmdJZj1cImxvYWRpbmdTdGF0dXMgPT09IExvYWRpbmdTdGF0dXMuRkFJTEVEXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICBbbGV2ZWxdPVwiTWVzc2FnZUxldmVsLkVSUk9SXCIgW3RleHRdPVwiJ3dvYS5lcnJvci5vcmRlci5pbml0aWF0aW9uRmFpbGVkJ1wiPlxuICAgICAgICA8d29hLWxpbmsgW2xpbmtdPVwiJ3dvYS5idXR0b24uY29tbW9uLnJldHJ5J1wiIChvbkFjdGl2YXRlKT1cImxvYWQoKVwiPjwvd29hLWxpbms+XG4gICAgPC93b2EtY29udGVudC1tZXNzYWdlPlxuICAgIDx3b2Etb3JkZXItZGV0YWlscy1wYW5lbCAqbmdJZj1cInJlc3BvbnNpdmVTZXJ2aWNlLmRlc2t0b3AkIHwgYXN5bmNcIiBjbGFzcz1cIm9yZGVyLWRldGFpbHNcIiBzbG90PVwiY29udGVudC1sZWZ0XCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgW3JlY2VudE9yZGVyXT1cInJlY2VudE9yZGVyXCIgW3Nob3dQYXltZW50XT1cImZhbHNlXCI+PC93b2Etb3JkZXItZGV0YWlscy1wYW5lbD5cbiAgICA8ZGl2ICpuZ0lmPVwiIW9yZGVyaW5nQ29udGV4dE1vZGVsLmlzQ29uZmlybWVkVGFibGVPcmRlcmluZ1wiXG4gICAgICAgICBjbGFzcz1cIm9yZGVyaW5nLWNvbnRleHRcIiB3b2EtcmVzcG9uc2l2ZSBzbG90PVwiY29udGVudC1yaWdodFwiPlxuICAgICAgICA8d29hLW9yZGVyaW5nLWNvbnRleHQtcGFuZWwgW3RpbWVPbmx5XT1cInRydWVcIj48L3dvYS1vcmRlcmluZy1jb250ZXh0LXBhbmVsPlxuICAgICAgICA8d29hLWNvbnRlbnQtbWVzc2FnZSAqbmdJZj1cIm9yZGVyTW9kZWwub3JkZXJFcnJvclN0YXRlcy5vcmRlcldpdGhJbnZhbGlkVGltZUF0dGVtcHRlZFwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgIFtsZXZlbF09XCJNZXNzYWdlTGV2ZWwuRVJST1JcIiBbdGV4dF09XCJvcmRlck1vZGVsLmludmFsaWRPcmRlclRpbWVNZXNzYWdlXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgW3RyYW5zbGF0aW9uUGFyYW1zXT1cIntzdG9yZU5hbWU6IG9yZGVyaW5nQ29udGV4dE1vZGVsLmN1cnJlbnRTdG9yZT8ubmFtZX1cIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICBbY2xvc2FibGVdPVwidHJ1ZVwiIChvbkNsb3NlKT1cIm9yZGVyTW9kZWwub3JkZXJFcnJvclN0YXRlcy5vcmRlcldpdGhJbnZhbGlkVGltZUF0dGVtcHRlZCA9IGZhbHNlXCI+PC93b2EtY29udGVudC1tZXNzYWdlPlxuICAgIDwvZGl2PlxuICAgIDx3b2EtZm9ybSBjbGFzcz1cIm9yZGVyLXBsYWNlbWVudFwiIHdvYS1yZXNwb25zaXZlIHNsb3Q9XCJjb250ZW50LXJpZ2h0XCIgKG9uU3VibWl0KT1cInBsYWNlT3JkZXIoKVwiPlxuICAgICAgICA8d29hLWZpZWxkLWdyb3VwICpuZ0lmPVwib3JkZXJNb2RlbC5wYXltZW50UmVxdWlyZWQgJiYgIXNlc3Npb25Nb2RlbC53YWl0ZXJNb2RlXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICBjbGFzcz1cIm9yZGVyLXBsYWNlbWVudC1vcHRpb25zXCIgW3RpdGxlXT1cIid3b2EuaGVhZGluZy5wYXltZW50LnBheW1lbnRPcHRpb25zJ1wiPlxuICAgICAgICAgICAgPHdvYS1yYWRpby1maWVsZCAqbmdGb3I9XCJsZXQgdGFyZ2V0IG9mIG9yZGVyTW9kZWwuaW5pdGlhdGVkT3JkZXIuYXZhaWxhYmxlVHJhbnNmZXJUYXJnZXRzXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgW2xhYmVsXT1cIid3b2EubGFiZWwucGF5bWVudC5wYXlXaXRoR3JvdXBPcmRlcidcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICBbdHJhbnNsYXRpb25QYXJhbXNdPVwieydncm91cE9yZGVyTmFtZSc6IHRhcmdldC5uYW1lIHwgcG9zc2Vzc2l2ZX1cIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICBbc2VsZWN0ZWRdPVwicGF5bWVudFR5cGUgPT09IFBheW1lbnRUeXBlLkdST1VQX1BBWSAmJiB0cmFuc2ZlclRhcmdldCA9PT0gdGFyZ2V0XCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgKHNlbGVjdGVkQ2hhbmdlKT1cInNlbGVjdFRyYW5zZmVyVGFyZ2V0KHRhcmdldClcIj5cbiAgICAgICAgICAgICAgICA8d29hLWljb24gW25hbWVdPVwiJ3VzZXJzJ1wiPjwvd29hLWljb24+XG4gICAgICAgICAgICA8L3dvYS1yYWRpby1maWVsZD5cbiAgICAgICAgICAgIDx3b2EtcmFkaW8tZmllbGQgKm5nSWY9XCJwYXltZW50TW9kZWwuY2FuTWFrZUFwcGxlUGF5UGF5bWVudFwiIFtsYWJlbF09XCInd29hLmxhYmVsLnBheW1lbnQucGF5V2l0aEFwcGxlUGF5J1wiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgIFtzZWxlY3RlZF09XCJwYXltZW50VHlwZSA9PT0gUGF5bWVudFR5cGUuQVBQTEVfUEFZXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgKHNlbGVjdGVkQ2hhbmdlKT1cInBheW1lbnRUeXBlID0gUGF5bWVudFR5cGUuQVBQTEVfUEFZXCI+XG4gICAgICAgICAgICAgICAgPHdvYS1pY29uIGNsYXNzPVwiYXBwbGUtcGF5LW1hcmtcIiBbbmFtZV09XCInYXBwbGUtcGF5LW1hcmsnXCI+PC93b2EtaWNvbj5cbiAgICAgICAgICAgIDwvd29hLXJhZGlvLWZpZWxkPlxuICAgICAgICAgICAgPHdvYS1yYWRpby1maWVsZCAqbmdJZj1cInBheW1lbnRNb2RlbC5jYW5NYWtlR29vZ2xlUGF5UGF5bWVudFwiIFtsYWJlbF09XCInd29hLmxhYmVsLnBheW1lbnQucGF5V2l0aEdvb2dsZVBheSdcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICBbc2VsZWN0ZWRdPVwicGF5bWVudFR5cGUgPT09IFBheW1lbnRUeXBlLkdPT0dMRV9QQVlcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAoc2VsZWN0ZWRDaGFuZ2UpPVwicGF5bWVudFR5cGUgPSBQYXltZW50VHlwZS5HT09HTEVfUEFZXCI+XG4gICAgICAgICAgICAgICAgPHdvYS1pY29uIGNsYXNzPVwiZ29vZ2xlLXBheS1tYXJrXCIgW25hbWVdPVwiJ2dvb2dsZS1wYXktbWFyaydcIj48L3dvYS1pY29uPlxuICAgICAgICAgICAgPC93b2EtcmFkaW8tZmllbGQ+XG4gICAgICAgICAgICA8d29hLXJhZGlvLWZpZWxkICpuZ0lmPVwic2hvd1NhdmVkQ3JlZGl0Q2FyZFBheW1lbnRcIiBbbGFiZWxdPVwiJ3dvYS5sYWJlbC5wYXltZW50LnBheVdpdGhTYXZlZENhcmQnXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgW3RyYW5zbGF0aW9uUGFyYW1zXT1cInsnY2FyZExhc3Q0JzogcGF5bWVudE1vZGVsLmNhcmRMYXN0NH1cIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICBbc2VsZWN0ZWRdPVwicGF5bWVudFR5cGUgPT09IFBheW1lbnRUeXBlLlNBVkVEX0NSRURJVF9DQVJEXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgKHNlbGVjdGVkQ2hhbmdlKT1cInBheW1lbnRUeXBlID0gUGF5bWVudFR5cGUuU0FWRURfQ1JFRElUX0NBUkRcIj5cbiAgICAgICAgICAgICAgICA8d29hLWNhcmQtYnJhbmQgW2JyYW5kXT1cInBheW1lbnRNb2RlbC5jYXJkQnJhbmRcIj48L3dvYS1jYXJkLWJyYW5kPlxuICAgICAgICAgICAgICAgIDx3b2EtbGluayBzbG90PVwiYWN0aW9uXCIgW2xpbmtdPVwiJ3dvYS5idXR0b24ucGF5bWVudC5mb3JnZXRDYXJkJ1wiIChvbkFjdGl2YXRlKT1cImZvcmdldENhcmQoKVwiPjwvd29hLWxpbms+XG4gICAgICAgICAgICA8L3dvYS1yYWRpby1maWVsZD5cbiAgICAgICAgICAgIDx3b2EtcmFkaW8tZmllbGQgKm5nSWY9XCJzaG93TmV3Q3JlZGl0Q2FyZFBheW1lbnRcIiAjbmV3Q2FyZCBbc29mdFJlc2l6ZU9uU2VsZWN0XT1cInRydWVcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICBbbGFiZWxdPVwic2hvd1NhdmVkQ3JlZGl0Q2FyZFBheW1lbnQgPyAnd29hLmxhYmVsLnBheW1lbnQucGF5V2l0aE5ld0NhcmQnIDogJ3dvYS5sYWJlbC5wYXltZW50LnBheVdpdGhDYXJkJ1wiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgIFtzZWxlY3RlZF09XCJwYXltZW50VHlwZSA9PT0gUGF5bWVudFR5cGUuTkVXX0NSRURJVF9DQVJEXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgKHNlbGVjdGVkQ2hhbmdlKT1cInBheW1lbnRUeXBlID0gUGF5bWVudFR5cGUuTkVXX0NSRURJVF9DQVJEXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgKG9uQWN0aXZhdGVMYWJlbCk9XCJjb3B5RGVmYXVsdENhcmROcigpXCI+XG4gICAgICAgICAgICAgICAgPHdvYS1jYXJkLWJyYW5kIFticmFuZF09XCInVmlzYSdcIj48L3dvYS1jYXJkLWJyYW5kPlxuICAgICAgICAgICAgICAgIDx3b2EtY2FyZC1icmFuZCBbYnJhbmRdPVwiJ01hc3RlcmNhcmQnXCI+PC93b2EtY2FyZC1icmFuZD5cbiAgICAgICAgICAgICAgICA8d29hLWNhcmQtYnJhbmQgW2JyYW5kXT1cIidBbWV4J1wiPjwvd29hLWNhcmQtYnJhbmQ+XG4gICAgICAgICAgICAgICAgPHdvYS1zdHJpcGUtbWFudWFsLXBheW1lbnQtY2FyZC1wYW5lbCAqbmdJZj1cInBheW1lbnRNb2RlbC5wYXltZW50UHJvdmlkZXIgPT09IEludGVncmF0ZWRQYXltZW50UHJvdmlkZXIuU1RSSVBFXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHNsb3Q9XCJkZXRhaWxzXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIFtkaXNhYmxlZF09XCIoT3JkZXJFdmVudHMub3JkZXJTdWJtaXNzaW9uU3RhdHVzJCB8IGFzeW5jKSA9PT0gT3JkZXJTdWJtaXNzaW9uU3RhdHVzLlNVQk1JVFRJTkdcIj48L3dvYS1zdHJpcGUtbWFudWFsLXBheW1lbnQtY2FyZC1wYW5lbD5cbiAgICAgICAgICAgICAgICA8d29hLXR5cm8tbWFudWFsLXBheW1lbnQtY2FyZC1wYW5lbCAqbmdJZj1cInBheW1lbnRNb2RlbC5wYXltZW50UHJvdmlkZXIgPT09IEludGVncmF0ZWRQYXltZW50UHJvdmlkZXIuVFlST1wiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgc2xvdD1cImRldGFpbHNcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIFtoaWRkZW5dPVwicGF5bWVudFR5cGUgIT09IFBheW1lbnRUeXBlLk5FV19DUkVESVRfQ0FSRFwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgW2Rpc2FibGVkXT1cIihPcmRlckV2ZW50cy5vcmRlclN1Ym1pc3Npb25TdGF0dXMkIHwgYXN5bmMpID09PSBPcmRlclN1Ym1pc3Npb25TdGF0dXMuU1VCTUlUVElOR1wiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgKG9uUGF5Rm9ybVJlYWR5KT1cIm5ld0NhcmQuc2V0SGVpZ2h0KClcIj48L3dvYS10eXJvLW1hbnVhbC1wYXltZW50LWNhcmQtcGFuZWw+XG4gICAgICAgICAgICAgICAgPHdvYS1hZHllbi1tYW51YWwtcGF5bWVudC1jYXJkLXBhbmVsICpuZ0lmPVwicGF5bWVudE1vZGVsLnBheW1lbnRQcm92aWRlciA9PT0gSW50ZWdyYXRlZFBheW1lbnRQcm92aWRlci5PT0xJT1wiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHNsb3Q9XCJkZXRhaWxzXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgW2hpZGRlbl09XCJwYXltZW50VHlwZSAhPT0gUGF5bWVudFR5cGUuTkVXX0NSRURJVF9DQVJEXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgW2Rpc2FibGVkXT1cIihPcmRlckV2ZW50cy5vcmRlclN1Ym1pc3Npb25TdGF0dXMkIHwgYXN5bmMpID09PSBPcmRlclN1Ym1pc3Npb25TdGF0dXMuU1VCTUlUVElOR1wiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIChvblBheUZvcm1SZWFkeSk9XCJuZXdDYXJkLnNldEhlaWdodCgpXCI+PC93b2EtYWR5ZW4tbWFudWFsLXBheW1lbnQtY2FyZC1wYW5lbD5cbiAgICAgICAgICAgIDwvd29hLXJhZGlvLWZpZWxkPlxuICAgICAgICAgICAgPHdvYS1yYWRpby1maWVsZCAqbmdJZj1cInNob3dQb2ludHNQYXltZW50XCIgW2Rpc2FibGVkXT1cIiFjYW5QYXlXaXRoUG9pbnRzXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgW2xhYmVsXT1cImNhblBheVdpdGhQb2ludHMgPyAnd29hLmxhYmVsLnBheW1lbnQucGF5V2l0aFBvaW50cycgOiAnd29hLmxhYmVsLnBheW1lbnQucG9pbnRzUmVxdWlyZWQnXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgW21lc3NhZ2VdPVwiJ3dvYS5tZXNzYWdlLnBheW1lbnQucG9pbnRzQmFsYW5jZSdcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICBbdHJhbnNsYXRpb25QYXJhbXNdPVwie1xuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgJ2Ftb3VudCc6IG9yZGVyTW9kZWwuaW5pdGlhdGVkT3JkZXI/Lm1lbWJlckF2YWlsYWJsZVJlZGVtcHRpb25Qb2ludHMsXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAncmVxdWlyZWQnOiBvcmRlck1vZGVsLmluaXRpYXRlZE9yZGVyPy5wb2ludHNSZWRlZW1hYmxlLFxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgJ2JhbGFuY2UnOiBvcmRlck1vZGVsLmluaXRpYXRlZE9yZGVyPy5tZW1iZXJQb2ludHNCYWxhbmNlXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgIH1cIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICBbc2VsZWN0ZWRdPVwicGF5bWVudFR5cGUgPT09IFBheW1lbnRUeXBlLlBPSU5UU1wiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgIChzZWxlY3RlZENoYW5nZSk9XCJwYXltZW50VHlwZSA9IFBheW1lbnRUeXBlLlBPSU5UU1wiPlxuICAgICAgICAgICAgICAgIDx3b2EtaWNvbiBbbmFtZV09XCInc3RhcidcIj48L3dvYS1pY29uPlxuICAgICAgICAgICAgPC93b2EtcmFkaW8tZmllbGQ+XG4gICAgICAgIDwvd29hLWZpZWxkLWdyb3VwPlxuICAgICAgICA8d29hLWZpZWxkLWdyb3VwICpuZ0lmPVwib3JkZXJNb2RlbC5wYXltZW50UmVxdWlyZWQgJiYgc2Vzc2lvbk1vZGVsLndhaXRlck1vZGVcIlxuICAgICAgICAgICAgICAgICAgICAgICAgIGNsYXNzPVwib3JkZXItcGxhY2VtZW50LWNhcmQtZGV0YWlsc1wiIFt0aXRsZV09XCInd29hLmhlYWRpbmcucGF5bWVudC5jYXJkRGV0YWlscydcIlxuICAgICAgICAgICAgICAgICAgICAgICAgIChvbkFjdGl2YXRlVGl0bGUpPVwiY29weURlZmF1bHRDYXJkTnIoKVwiPlxuICAgICAgICAgICAgPHdvYS1zdHJpcGUtc2Nhbm5lZC1wYXltZW50LWNhcmQtcGFuZWwgKm5nSWY9XCJzY2FubmVkQ2FyZFwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBbZGlzYWJsZWRdPVwiIXNob3dDYXJkRGV0YWlscyB8fCAoT3JkZXJFdmVudHMub3JkZXJTdWJtaXNzaW9uU3RhdHVzJCB8IGFzeW5jKSA9PT0gT3JkZXJTdWJtaXNzaW9uU3RhdHVzLlNVQk1JVFRJTkdcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgW2NhcmROdW1iZXJdPVwic2Nhbm5lZENhcmQuZm9ybWF0dGVkQ2FyZE51bWJlclwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBbY2FyZEV4cGlyeV09XCJzY2FubmVkQ2FyZC5leHBpcnlcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgKG9uQ2hhbmdlQ2FyZCk9XCJzY2FubmVkQ2FyZCA9IHVuZGVmaW5lZFwiPjwvd29hLXN0cmlwZS1zY2FubmVkLXBheW1lbnQtY2FyZC1wYW5lbD5cbiAgICAgICAgICAgIDwhLS1zdXBwcmVzcyBQb2ludGxlc3NCb29sZWFuRXhwcmVzc2lvbkpTIC0tPlxuICAgICAgICAgICAgPHdvYS1zdHJpcGUtbWFudWFsLXBheW1lbnQtY2FyZC1wYW5lbCAqbmdJZj1cIiFzY2FubmVkQ2FyZCAmJiBwYXltZW50TW9kZWwucGF5bWVudFByb3ZpZGVyID09PSBJbnRlZ3JhdGVkUGF5bWVudFByb3ZpZGVyLlNUUklQRVwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIFtkaXNhYmxlZF09XCIhc2hvd0NhcmREZXRhaWxzIHx8IChPcmRlckV2ZW50cy5vcmRlclN1Ym1pc3Npb25TdGF0dXMkIHwgYXN5bmMpID09PSBPcmRlclN1Ym1pc3Npb25TdGF0dXMuU1VCTUlUVElOR1wiPjwvd29hLXN0cmlwZS1tYW51YWwtcGF5bWVudC1jYXJkLXBhbmVsPlxuICAgICAgICAgICAgPCEtLXN1cHByZXNzIFBvaW50bGVzc0Jvb2xlYW5FeHByZXNzaW9uSlMgLS0+XG4gICAgICAgICAgICA8d29hLXR5cm8tbWFudWFsLXBheW1lbnQtY2FyZC1wYW5lbCAqbmdJZj1cIiFzY2FubmVkQ2FyZCAmJiBwYXltZW50TW9kZWwucGF5bWVudFByb3ZpZGVyID09PSBJbnRlZ3JhdGVkUGF5bWVudFByb3ZpZGVyLlRZUk9cIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgW2Rpc2FibGVkXT1cIiFzaG93Q2FyZERldGFpbHMgfHwgKE9yZGVyRXZlbnRzLm9yZGVyU3VibWlzc2lvblN0YXR1cyQgfCBhc3luYykgPT09IE9yZGVyU3VibWlzc2lvblN0YXR1cy5TVUJNSVRUSU5HXCI+PC93b2EtdHlyby1tYW51YWwtcGF5bWVudC1jYXJkLXBhbmVsPlxuICAgICAgICA8L3dvYS1maWVsZC1ncm91cD5cbiAgICAgICAgPHdvYS1maWVsZC1ncm91cCAqbmdJZj1cIm9yZGVyaW5nQ29udGV4dE1vZGVsLmlzQ29uZmlybWVkRGVsaXZlcnlPcmRlcmluZ1wiICNkZWxpdmVyeURldGFpbHNcbiAgICAgICAgICAgICAgICAgICAgICAgICBbdGl0bGVdPVwiJ3dvYS5oZWFkaW5nLnBheW1lbnQuZGVsaXZlcnlEZXRhaWxzJ1wiPlxuICAgICAgICAgICAgPHdvYS1waG9uZS1udW1iZXItZmllbGQgKm5nSWY9XCJzaG93UGhvbmVOdW1iZXJGaWVsZFwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBbKG5nTW9kZWwpXT1cIm1vYmlsZVBob25lXCIgbmFtZT1cIm1vYmlsZVBob25lXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIFtsYWJlbF09XCInd29hLmxhYmVsLmNvbW1vbi5tb2JpbGUnXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIFtyZXF1aXJlZF09XCJvcmRlcmluZ0NvbnRleHRNb2RlbC5yZXF1aXJlUGhvbmVOdW1iZXJcIiB3b2EtcGhvbmUtbnVtYmVyPjwvd29hLXBob25lLW51bWJlci1maWVsZD5cbiAgICAgICAgICAgIDx3b2EtdGV4dC1hcmVhLWZpZWxkIFsobmdNb2RlbCldPVwib3JkZXJpbmdDb250ZXh0TW9kZWwuZGVsaXZlcnlJbnN0cnVjdGlvbnNcIiBuYW1lPVwiZGVsaXZlcnlJbnN0cnVjdGlvbnNcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgW2xhYmVsXT1cIid3b2EubGFiZWwuYWRkcmVzcy5kZWxpdmVyeUluc3RydWN0aW9ucydcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgW21heGxlbmd0aF09XCInMjU1J1wiPjwvd29hLXRleHQtYXJlYS1maWVsZD5cbiAgICAgICAgPC93b2EtZmllbGQtZ3JvdXA+XG4gICAgICAgIDx3b2EtZmllbGQtZ3JvdXAgKm5nSWY9XCJzaG93Q3VzdG9tZXJEZXRhaWxzXCIgI2N1c3RvbWVyRGV0YWlsc1xuICAgICAgICAgICAgICAgICAgICAgICAgIGNsYXNzPVwib3JkZXItcGxhY2VtZW50LWN1c3RvbWVyLWRldGFpbHNcIiBbdGl0bGVdPVwiJ3dvYS5oZWFkaW5nLnBheW1lbnQuY3VzdG9tZXJEZXRhaWxzJ1wiPlxuICAgICAgICAgICAgPHdvYS1maWVsZC1wYWlyICpuZ0lmPVwic2hvd05hbWVGaWVsZFwiPlxuICAgICAgICAgICAgICAgIDx3b2EtdGV4dC1maWVsZCBbKG5nTW9kZWwpXT1cImZpcnN0TmFtZVwiIG5hbWU9XCJmaXJzdE5hbWVcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBbbGFiZWxdPVwiJ3dvYS5sYWJlbC5jb21tb24uZmlyc3ROYW1lJ1wiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIFtyZXF1aXJlZF09XCJyZXF1aXJlRmlyc3ROYW1lXCIgW21heGxlbmd0aF09XCInMzAnXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgW2F1dG9jb21wbGV0ZV09XCInZ2l2ZW4tbmFtZSdcIiBbc3BlbGxjaGVja109XCJmYWxzZVwiPjwvd29hLXRleHQtZmllbGQ+XG4gICAgICAgICAgICAgICAgPHdvYS10ZXh0LWZpZWxkIFsobmdNb2RlbCldPVwibGFzdE5hbWVcIiBuYW1lPVwibGFzdE5hbWVcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBbbGFiZWxdPVwiJ3dvYS5sYWJlbC5jb21tb24ubGFzdE5hbWUnXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgW3JlcXVpcmVkXT1cInJlcXVpcmVMYXN0TmFtZVwiIFttYXhsZW5ndGhdPVwiJzMwJ1wiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIFthdXRvY29tcGxldGVdPVwiJ2ZhbWlseS1uYW1lJ1wiIFtzcGVsbGNoZWNrXT1cImZhbHNlXCI+PC93b2EtdGV4dC1maWVsZD5cbiAgICAgICAgICAgIDwvd29hLWZpZWxkLXBhaXI+XG4gICAgICAgICAgICA8d29hLWVtYWlsLWZpZWxkICpuZ0lmPVwic2hvd0VtYWlsRmllbGRcIiBbKG5nTW9kZWwpXT1cImVtYWlsXCIgbmFtZT1cImVtYWlsXCIgW2xhYmVsXT1cImVtYWlsTGFiZWxcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICBbcmVxdWlyZWRdPVwicmVxdWlyZUVtYWlsXCIgd29hLWVtYWlsPjwvd29hLWVtYWlsLWZpZWxkPlxuICAgICAgICAgICAgPHdvYS1waG9uZS1udW1iZXItZmllbGQgKm5nSWY9XCJzaG93UGhvbmVOdW1iZXJGaWVsZCAmJiAhb3JkZXJpbmdDb250ZXh0TW9kZWwuaXNDb25maXJtZWREZWxpdmVyeU9yZGVyaW5nXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIFsobmdNb2RlbCldPVwibW9iaWxlUGhvbmVcIiBuYW1lPVwibW9iaWxlUGhvbmVcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgW2xhYmVsXT1cIid3b2EubGFiZWwuY29tbW9uLm1vYmlsZSdcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgW3JlcXVpcmVkXT1cInJlcXVpcmVQaG9uZU51bWJlclwiIHdvYS1waG9uZS1udW1iZXI+PC93b2EtcGhvbmUtbnVtYmVyLWZpZWxkPlxuICAgICAgICAgICAgPHdvYS1zZWxlY3Rvci1jb250cm9sICpuZ0lmPVwib3JkZXJpbmdDb250ZXh0TW9kZWwuc2hvd01hcmtldGluZ09wdEluXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBjbGFzcz1cIm9yZGVyLXBsYWNlbWVudC1jdXN0b21lci1kZXRhaWxzLW1hcmtldGluZ1wiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgWyhzZWxlY3RlZCldPVwib3JkZXJpbmdDb250ZXh0TW9kZWwubWFya2V0aW5nT3B0SW5cIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIFtsYWJlbF09XCInd29hLmxhYmVsLmNvbW1vbi5tYXJrZXRpbmdPcHRJbidcIj48L3dvYS1zZWxlY3Rvci1jb250cm9sPlxuICAgICAgICA8L3dvYS1maWVsZC1ncm91cD5cbiAgICAgICAgPHdvYS10aXAtc2VsZWN0aW9uLXBhbmVsICpuZ0lmPVwic2hvd1RpcHNcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgY2xhc3M9XCJvcmRlci1wbGFjZW1lbnQtdGlwXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIFtzaG93VGlwSW5zdHJ1Y3Rpb25zXT1cInRydWVcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgWyh0aXBBbW91bnQpXT1cIm9yZGVyTW9kZWwudGlwQW1vdW50XCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIFsodGlwU2VsZWN0ZWQpXT1cIm9yZGVyaW5nQ29udGV4dE1vZGVsLnRpcFNlbGVjdGVkXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICh0aXBBbW91bnRDaGFuZ2UpPVwidGlwQ2hhbmdlZCgpXCI+PC93b2EtdGlwLXNlbGVjdGlvbi1wYW5lbD5cbiAgICA8L3dvYS1mb3JtPlxuICAgIDx3b2Etb3JkZXItdG90YWxzLXBhbmVsIHNsb3Q9XCJmb290ZXItc3RhcnRcIiBjbGFzcz1cInBheW1lbnQtdG90YWxzXCIgW3RvdGFsT25seV09XCJ0cnVlXCI+PC93b2Etb3JkZXItdG90YWxzLXBhbmVsPlxuICAgIDx3b2EtYnV0dG9uICpuZ0lmPVwicGF5bWVudFR5cGUgPT09IFBheW1lbnRUeXBlLk5PTkVcIiB3b2EtcGFnZS1mb290ZXItY29udHJvbFxuICAgICAgICAgICAgICAgIGlkPVwibm8tcGF5LWJ1dHRvblwiIFtsYWJlbF09XCInd29hLmJ1dHRvbi5wYXltZW50LnBsYWNlT3JkZXInXCJcbiAgICAgICAgICAgICAgICBbZGlzYWJsZWRdPVwic2Vzc2lvbk1vZGVsLnRpbWVUZXN0TW9kZVwiXG4gICAgICAgICAgICAgICAgKGNsaWNrKT1cImZvcm0uc3VibWl0KClcIj48L3dvYS1idXR0b24+XG4gICAgPHdvYS1idXR0b24gKm5nSWY9XCJzZXNzaW9uTW9kZWwud2FpdGVyTW9kZVwiIHdvYS1wYWdlLWZvb3Rlci1jb250cm9sXG4gICAgICAgICAgICAgICAgW2xhYmVsXT1cIid3b2EuYnV0dG9uLnBheW1lbnQucGxhY2VPcmRlcidcIiBpZD1cIndhaXRlci1wYXktYnV0dG9uXCJcbiAgICAgICAgICAgICAgICBbZGlzYWJsZWRdPVwic2Vzc2lvbk1vZGVsLnRpbWVUZXN0TW9kZVwiXG4gICAgICAgICAgICAgICAgKGNsaWNrKT1cImZvcm0uc3VibWl0KClcIj48L3dvYS1idXR0b24+XG4gICAgPHdvYS1idXR0b24gKm5nSWY9XCJwYXltZW50VHlwZSA9PT0gUGF5bWVudFR5cGUuR1JPVVBfUEFZXCIgd29hLXBhZ2UtZm9vdGVyLWNvbnRyb2xcbiAgICAgICAgICAgICAgICBpZD1cImdyb3VwLXBheS1idXR0b25cIiBbbGFiZWxdPVwiJ3dvYS5idXR0b24ucGF5bWVudC5wYXlXaXRoR3JvdXBPcmRlcidcIlxuICAgICAgICAgICAgICAgIFtkaXNhYmxlZF09XCJzZXNzaW9uTW9kZWwudGltZVRlc3RNb2RlXCJcbiAgICAgICAgICAgICAgICAoY2xpY2spPVwiZm9ybS5zdWJtaXQoKVwiPjwvd29hLWJ1dHRvbj5cbiAgICA8d29hLWFwcGxlLXBheS1idXR0b24gKm5nSWY9XCJwYXltZW50VHlwZSA9PT0gUGF5bWVudFR5cGUuQVBQTEVfUEFZXCIgd29hLXBhZ2UtZm9vdGVyLWNvbnRyb2xcbiAgICAgICAgICAgICAgICAgICAgICAgICAgaWQ9XCJhcHBsZS1wYXktYnV0dG9uXCIgW3Bhc3NpdmVPbmx5XT1cInRydWVcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICBbdHlwZV09XCJwYXltZW50TW9kZWwud2FsbGV0UGF5bWVudFByb2Nlc3Nvci5jYW5TdWJtaXQgPyAncGxhaW4nIDogJ2NoZWNrLW91dCdcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICBbZGlzYWJsZWRdPVwic2Vzc2lvbk1vZGVsLnRpbWVUZXN0TW9kZVwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgIChwYXkpPVwiZm9ybS5zdWJtaXQoKVwiPjwvd29hLWFwcGxlLXBheS1idXR0b24+XG4gICAgPHdvYS1nb29nbGUtcGF5LWJ1dHRvbiAqbmdJZj1cInBheW1lbnRUeXBlID09PSBQYXltZW50VHlwZS5HT09HTEVfUEFZXCIgd29hLXBhZ2UtZm9vdGVyLWNvbnRyb2xcbiAgICAgICAgICAgICAgICAgICAgICAgICAgIGlkPVwiZ29vZ2xlLXBheS1idXR0b25cIiBbcGFzc2l2ZV09XCJ0cnVlXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgIFt0eXBlXT1cInBheW1lbnRNb2RlbC53YWxsZXRQYXltZW50UHJvY2Vzc29yLmNhblN1Ym1pdCA/ICdwbGFpbicgOiAnY2hlY2tvdXQnXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgIFtkaXNhYmxlZF09XCJzZXNzaW9uTW9kZWwudGltZVRlc3RNb2RlXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgIChwYXkpPVwiZm9ybS5zdWJtaXQoKVwiPjwvd29hLWdvb2dsZS1wYXktYnV0dG9uPlxuICAgIDx3b2EtYnV0dG9uICpuZ0lmPVwicGF5bWVudFR5cGUgPT09IFBheW1lbnRUeXBlLlNBVkVEX0NSRURJVF9DQVJEIHx8IHBheW1lbnRUeXBlID09PSBQYXltZW50VHlwZS5ORVdfQ1JFRElUX0NBUkRcIiB3b2EtcGFnZS1mb290ZXItY29udHJvbFxuICAgICAgICAgICAgICAgIGlkPVwiY3JlZGl0LWNhcmQtcGF5LWJ1dHRvblwiIFtsYWJlbF09XCInd29hLmJ1dHRvbi5wYXltZW50LnBheVdpdGhDYXJkJ1wiXG4gICAgICAgICAgICAgICAgW3RyYW5zbGF0aW9uUGFyYW1zXT1cInsnYW1vdW50JzogKG9yZGVyTW9kZWwub3JkZXJUb3RhbFBheW1lbnQgfCB3b2FDdXJyZW5jeTogJ0FVJCcpfVwiXG4gICAgICAgICAgICAgICAgW2Rpc2FibGVkXT1cInNlc3Npb25Nb2RlbC50aW1lVGVzdE1vZGVcIlxuICAgICAgICAgICAgICAgIChjbGljayk9XCJmb3JtLnN1Ym1pdCgpXCI+PC93b2EtYnV0dG9uPlxuICAgIDx3b2EtYnV0dG9uICpuZ0lmPVwicGF5bWVudFR5cGUgPT09IFBheW1lbnRUeXBlLlBPSU5UU1wiIHdvYS1wYWdlLWZvb3Rlci1jb250cm9sXG4gICAgICAgICAgICAgICAgaWQ9XCJwb2ludHMtcGF5LWJ1dHRvblwiIFtsYWJlbF09XCInd29hLmJ1dHRvbi5wYXltZW50LnBheVdpdGhQb2ludHMnXCJcbiAgICAgICAgICAgICAgICBbdHJhbnNsYXRpb25QYXJhbXNdPVwieydhbW91bnQnOiBvcmRlck1vZGVsLmluaXRpYXRlZE9yZGVyPy5tZW1iZXJBdmFpbGFibGVSZWRlbXB0aW9uUG9pbnRzfVwiXG4gICAgICAgICAgICAgICAgW2Rpc2FibGVkXT1cInNlc3Npb25Nb2RlbC50aW1lVGVzdE1vZGVcIlxuICAgICAgICAgICAgICAgIChjbGljayk9XCJmb3JtLnN1Ym1pdCgpXCI+PC93b2EtYnV0dG9uPlxuICAgIDx3b2EtbGVnYWwtcGFuZWwgc2xvdD1cImZvb3Rlci1lbmRcIiBjbGFzcz1cInBheW1lbnQtbGVnYWxcIiBbbWVzc2FnZVNldF09XCIncGF5bWVudCdcIj48L3dvYS1sZWdhbC1wYW5lbD5cbjwvd29hLWZ1bGwtcGFnZS1sYXlvdXQ+XG4iLCI8d29hLXBheW1lbnQtcGFnZT48L3dvYS1wYXltZW50LXBhZ2U+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQ0dJO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtJQUFBO2dCQUFBOzs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtnQkFBQTtJQUM4RjtNQUMxRjtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtNQUE2QztRQUFBO1FBQUE7TUFBQTtNQUE3QztJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUE4RTs7OztJQUQ3RDtJQUE2QjtJQURsRCxTQUNxQixVQUE2QixTQURsRDtJQUVjO0lBQVYsU0FBVSxVQUFWOztJQUZKO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxTQUFBLCtFQUFBOzs7OztJQUlBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtnQkFBQTs7Ozs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTs7OztJQUN5QjtJQUE0QjtJQURyRCxTQUN5QixVQUE0QixTQURyRDs7Ozs7SUFLSTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUd1QztRQUFBO1FBQUE7TUFBQTtNQUh2QztJQUFBO2dCQUFBOzs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtnQkFBQTtnQkFFcUI7Ozs7SUFEQTtJQUE2QjtJQUM3QjtJQUNBO0lBSHJCLFNBQ3FCLFVBQTZCLFVBQzdCLFdBQ0EsVUFIckI7O0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFNBQUEsK0VBQUE7Ozs7O0lBSEo7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFBOzs7Ozs7SUFBQTtLQUFBO0lBQ2tFO0lBQzlEO2dCQUFBOzs7Ozs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBMkU7SUFDM0U7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUcySTs7OztJQU4vSTtJQUVnQztJQUE1QixTQUE0QixTQUE1QjtJQUNxQjtJQUFyQixTQUFxQixTQUFyQjs7Ozs7TUFRSTtRQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO01BQUE7TUFJaUI7UUFBQTtRQUFBO01BQUE7TUFKakI7SUFBQTtnQkFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBRWlCO2dCQUFBO0lBRWdEO0lBQzdEO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBc0M7Ozs7SUFKekI7SUFDQTtJQUNBO0lBSGpCLFNBQ2lCLFVBQ0EsVUFDQSxTQUhqQjtJQUtjO0lBQVYsU0FBVSxTQUFWOztJQUxKO0lBQUEsU0FBQSxTQUFBOzs7OztNQU9BO1FBQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtNQUVpQjtRQUFBO1FBQUE7TUFBQTtNQUZqQjtJQUFBO2dCQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtJQUV3RTtNQUNwRTtRQUFBO1FBQUE7TUFBQTtJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBc0U7Ozs7SUFIYjtJQUM1QztJQURqQixTQUE2RCxVQUM1QyxTQURqQjtJQUdxQztJQUFqQyxTQUFpQyxTQUFqQzs7SUFISjtJQUFBLFNBQUEsU0FBQTs7Ozs7TUFLQTtRQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO01BQUE7TUFFaUI7UUFBQTtRQUFBO01BQUE7TUFGakI7SUFBQTtnQkFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7SUFFeUU7TUFDckU7UUFBQTtRQUFBO01BQUE7SUFBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXdFOzs7O0lBSGQ7SUFDN0M7SUFEakIsU0FBOEQsVUFDN0MsU0FEakI7SUFHc0M7SUFBbEMsU0FBa0MsU0FBbEM7O0lBSEo7SUFBQSxTQUFBLFNBQUE7Ozs7O01BS0E7UUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BR2lCO1FBQUE7UUFBQTtNQUFBO01BSGpCO0lBQUE7Z0JBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUNpQjtJQUUrRDtNQUM1RTtRQUFBO1FBQUE7TUFBQTtJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBa0U7TUFDbEU7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtNQUFpRTtRQUFBO1FBQUE7TUFBQTtNQUFqRTtJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBd0c7Ozs7SUFMeEQ7SUFDbkM7SUFDQTtJQUZqQixTQUFvRCxVQUNuQyxVQUNBLFNBRmpCO0lBSW9CO0lBQWhCLFNBQWdCLFNBQWhCO0lBQ3dCO0lBQXhCLFNBQXdCLFNBQXhCOztJQUxKO0lBQUEsU0FBQSxTQUFBOzs7OztNQWVJO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBQTs7Ozs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUVzQztrQkFGdEM7UUFBQTtRQUFBO01BQUE7SUFBQTs7OztJQUVzQztJQUZ0QyxTQUVzQyxTQUZ0Qzs7Ozs7TUFHQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUlvQztRQUFBO1FBQUE7TUFBQTtNQUpwQztJQUFBO2dCQUFBOzs7Ozs7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBR29DO2tCQUhwQztRQUFBO1FBQUE7TUFBQTtJQUFBOzs7O0lBR29DO0lBREE7SUFGcEMsU0FHb0MsVUFEQSxTQUZwQzs7SUFBQTtJQUFBLFNBQUEsU0FBQTs7Ozs7TUFLQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUlxQztRQUFBO1FBQUE7TUFBQTtNQUpyQztJQUFBO2dCQUFBOzs7Ozs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtnQkFHcUM7a0JBSHJDO1FBQUE7UUFBQTtNQUFBO0lBQUE7Ozs7SUFHcUM7SUFEQTtJQUZyQyxTQUdxQyxVQURBLFNBRnJDOztJQUFBO0lBQUEsU0FBQSxTQUFBOzs7OztNQWhCSjtRQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7TUFBQTtNQUdpQjtRQUFBO1FBQUE7TUFBQTtNQUNBO1FBQUE7UUFBQTtNQUFBO01BSmpCO0lBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUl5RDtNQUNyRDtRQUFBO1FBQUE7TUFBQTtJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBa0Q7TUFDbEQ7UUFBQTtRQUFBO01BQUE7SUFBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXdEO01BQ3hEO1FBQUE7UUFBQTtNQUFBO0lBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFrRDtJQUNsRDtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBRTRLO0lBQzVLO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFJZ0g7SUFDaEg7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUlrSDs7OztJQW5Cckc7SUFEMEM7SUFFMUM7SUFGakIsU0FDaUIsVUFEMEMsVUFFMUMsU0FGakI7SUFLb0I7SUFBaEIsU0FBZ0IsU0FBaEI7SUFDZ0I7SUFBaEIsU0FBZ0IsU0FBaEI7SUFDZ0I7SUFBaEIsVUFBZ0IsU0FBaEI7SUFDc0M7SUFBdEMsVUFBc0MsU0FBdEM7SUFHb0M7SUFBcEMsVUFBb0MsU0FBcEM7SUFLcUM7SUFBckMsVUFBcUMsU0FBckM7O0lBaEJKO0lBQUEsU0FBQSxTQUFBOzs7OztNQXNCQTtRQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO01BQUE7TUFTaUI7UUFBQTtRQUFBO01BQUE7TUFUakI7SUFBQTtnQkFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBR2lCO01BQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTtJQU1vRDtJQUNqRTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXFDOzs7O0lBVHhCO0lBQ0E7SUFDQTtJQUgwQjtJQVExQjtJQVJqQixTQUNpQixVQUNBLFVBQ0EsVUFIMEIsVUFRMUIsU0FSakI7SUFVYztJQUFWLFNBQVUsU0FBVjs7SUFWSjtJQUFBLFNBQUEsU0FBQTs7Ozs7TUFoREo7UUFBQTtRQUFBO01BQUE7SUFBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUFBO01BQUE7SUFBQTtJQUNnRztJQUM1RjtnQkFBQTs7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQU1rQjtJQUNsQjtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBSWtCO0lBQ2xCO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFJa0I7SUFDbEI7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQU1rQjtJQUNsQjtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBcUJrQjtJQUNsQjtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBV2tCOzs7O0lBMUQyQjtJQURqRCxTQUNpRCxTQURqRDtJQUVxQjtJQUFqQixTQUFpQixTQUFqQjtJQU9pQjtJQUFqQixTQUFpQixTQUFqQjtJQUtpQjtJQUFqQixVQUFpQixTQUFqQjtJQUtpQjtJQUFqQixVQUFpQixTQUFqQjtJQU9pQjtJQUFqQixVQUFpQixTQUFqQjtJQXNCaUI7SUFBakIsVUFBaUIsU0FBakI7Ozs7O01BZ0JBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO01BQUE7TUFJdUM7UUFBQTtRQUFBO01BQUE7TUFKdkM7SUFBQTtnQkFBQTs7Ozs7OztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUN1QztrQkFEdkM7UUFBQTtRQUFBO01BQUE7SUFBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBOzs7O0lBQ3VDO0lBQ0E7SUFDQTtJQUh2QyxTQUN1QyxVQUNBLFVBQ0EsU0FIdkM7Ozs7O01BTUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBQTs7Ozs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUNzQztrQkFEdEM7UUFBQTtRQUFBO01BQUE7SUFBQTs7OztJQUNzQztJQUR0QyxTQUNzQyxTQUR0Qzs7Ozs7TUFHQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBQTs7Ozs7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFDb0M7a0JBRHBDO1FBQUE7UUFBQTtNQUFBO0lBQUE7Ozs7SUFDb0M7SUFEcEMsU0FDb0MsU0FEcEM7O0lBQUE7SUFBQSxTQUFBLFNBQUE7Ozs7O01BWko7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtNQUVpQjtRQUFBO1FBQUE7TUFBQTtNQUZqQjtJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQUE7TUFBQTtJQUFBO0lBRXlEO0lBQ3JEO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFJd0g7SUFDM0U7SUFDN0M7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUNnTTtJQUNuSjtJQUM3QztnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQzRMOzs7O0lBWjFJO0lBRHRELFNBQ3NELFNBRHREO0lBRzJDO0lBQXZDLFNBQXVDLFNBQXZDO0lBTXNDO0lBQXRDLFNBQXNDLFNBQXRDO0lBR29DO0lBQXBDLFVBQW9DLFNBQXBDOzs7OztJQUtBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BQ3dCO1FBQUE7UUFBQTtNQUFBO01BRHhCO0lBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBQTtnQkFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7SUFBQTs7O0lBQUE7SUFBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUFBO01BQUE7SUFBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTs7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBOztNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFBO2dCQUFBOzs7O0lBR3dCO0lBSHhCLFNBR3dCLFNBSHhCO0lBRXdCO0lBRnhCLFNBRXdCLFNBRnhCO0lBQ2tEO0lBQTFCO0lBRHhCLFNBQ2tELFdBQTFCLFVBRHhCOztJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxTQUFBLFVBQUEscUVBQUE7Ozs7O01BRko7UUFBQTtRQUFBO01BQUE7SUFBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQUE7TUFBQTtJQUFBO0lBQ2lFO0lBQzdEO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFHdUg7TUFDdkg7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BQXFCO1FBQUE7UUFBQTtNQUFBO01BQXJCO0lBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBQTtNQUFBO0lBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBQTtNQUFBO0lBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7O01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTs7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtnQkFBQTtnQkFBQTtJQUUrRDs7OztJQVBsRDtJQURqQixTQUNpQixTQURqQjtJQUU0QjtJQUF4QixTQUF3QixTQUF4QjtJQU1xQjtJQUZyQixTQUVxQixVQUZyQjtJQUNxQjtJQURyQixVQUNxQixVQURyQjtJQUE2RTtJQUF4RDtJQUFyQixVQUE2RSxXQUF4RCxVQUFyQjs7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsU0FBQSxVQUFBLHFFQUFBOzs7OztJQU1BO2dCQUFBO2dCQUFBO01BQUE7SUFBQTtJQUFzQztNQUNsQztRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtNQUFnQjtRQUFBO1FBQUE7TUFBQTtNQUFoQjtJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7SUFBQTs7O0lBQUE7SUFBQTtnQkFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQUE7TUFBQTtJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBOztNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7O01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQUE7Z0JBQUE7SUFHb0Y7TUFDcEY7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO01BQUE7TUFBZ0I7UUFBQTtRQUFBO01BQUE7TUFBaEI7SUFBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO0lBQUE7OztJQUFBO0lBQUE7Z0JBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFBO01BQUE7SUFBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTs7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBOztNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFBO2dCQUFBO0lBR3FGOzs7O0lBTHJFO0lBRmhCLFNBRWdCLFNBRmhCO0lBRThDO0lBRjlDLFNBRThDLFVBRjlDO0lBQ2dCO0lBRUE7SUFEOEI7SUFDQTtJQUg5QyxTQUNnQixXQUVBLFdBRDhCLFdBQ0EsVUFIOUM7SUFBd0M7SUFBeEI7SUFBaEIsVUFBd0MsV0FBeEIsVUFBaEI7SUFNZ0I7SUFGaEIsVUFFZ0IsVUFGaEI7SUFFNkM7SUFGN0MsVUFFNkMsVUFGN0M7SUFDZ0I7SUFFQTtJQUQ2QjtJQUNFO0lBSC9DLFVBQ2dCLFdBRUEsV0FENkIsV0FDRSxVQUgvQztJQUF1QztJQUF2QjtJQUFoQixVQUF1QyxXQUF2QixVQUFoQjs7SUFKQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxTQUFBLFVBQUEsVUFBQSxxRUFBQTtJQUlBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFVBQUEsV0FBQSxXQUFBLDRFQUFBOzs7OztJQUtKO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BQXdDO1FBQUE7UUFBQTtNQUFBO01BQXhDO0lBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBQTtnQkFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7SUFBQTs7O0lBQUE7SUFBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUFBO01BQUE7SUFBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTs7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBOztNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFBO2dCQUFBOzs7O0lBQ2lCO0lBRGpCLFNBQ2lCLFNBRGpCO0lBQXlFO0lBQXpFLFNBQXlFLFNBQXpFO0lBQTREO0lBQXBCO0lBQXhDLFNBQTRELFdBQXBCLFVBQXhDOztJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxTQUFBLFVBQUEscUVBQUE7Ozs7O0lBRUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO01BQUE7TUFDd0I7UUFBQTtRQUFBO01BQUE7TUFEeEI7SUFBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUFBO2dCQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtJQUFBOzs7SUFBQTtJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQUE7TUFBQTtJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBOztNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7O01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQUE7Z0JBQUE7Ozs7SUFHd0I7SUFIeEIsU0FHd0IsU0FIeEI7SUFFd0I7SUFGeEIsU0FFd0IsU0FGeEI7SUFDa0Q7SUFBMUI7SUFEeEIsU0FDa0QsV0FBMUIsVUFEeEI7O0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFNBQUEsVUFBQSxxRUFBQTs7Ozs7TUFJQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO01BQUE7TUFFc0I7UUFBQTtRQUFBO01BQUE7TUFGdEI7SUFBQTtnQkFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Ozs7SUFFc0I7SUFDQTtJQUh0QixTQUVzQixVQUNBLFNBSHRCOztJQUFBO0lBQUE7SUFBQSxTQUFBLG1CQUFBOzs7OztNQWxCSjtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUFBO01BQUE7SUFBQTtJQUMwRztJQUN0RztnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBU2lCO0lBQ2pCO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFDdUU7SUFDdkU7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUdrRztJQUNsRztnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBR3lGOzs7O0lBcEJuQztJQUQxRCxTQUMwRCxTQUQxRDtJQUVvQjtJQUFoQixTQUFnQixTQUFoQjtJQVVpQjtJQUFqQixTQUFpQixTQUFqQjtJQUV3QjtJQUF4QixVQUF3QixTQUF4QjtJQUlzQjtJQUF0QixVQUFzQixTQUF0Qjs7Ozs7TUFLSjtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO01BQUE7TUFHeUI7UUFBQTtRQUFBO01BQUE7TUFDQTtRQUFBO1FBQUE7TUFBQTtNQUNBO1FBQUE7UUFBQTtNQUFBO01BTHpCO0lBQUE7Z0JBQUE7OztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7TUFBQTtJQUFBO0lBQUE7Ozs7SUFHeUI7SUFDQTtJQUZBO0lBRnpCLFNBR3lCLFVBQ0EsVUFGQSxTQUZ6Qjs7Ozs7SUFRSjtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFHWTtRQUFBO1FBQUE7TUFBQTtNQUhaO0lBQUE7Z0JBQUE7Ozs7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTs7OztJQUMrQjtJQUNuQjtJQUZaLFNBQytCLFdBQ25CLFVBRlo7O0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7SUFBQTtJQUFBOzs7OztJQUlBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUdZO1FBQUE7UUFBQTtNQUFBO01BSFo7SUFBQTtnQkFBQTs7Ozs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBOzs7O0lBQ1k7SUFDQTtJQUZaLFNBQ1ksV0FDQSxVQUZaOztJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTs7Ozs7SUFJQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFHWTtRQUFBO1FBQUE7TUFBQTtNQUhaO0lBQUE7Z0JBQUE7Ozs7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTs7OztJQUNrQztJQUN0QjtJQUZaLFNBQ2tDLFdBQ3RCLFVBRlo7O0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7SUFBQTtJQUFBOzs7OztJQUlBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUlzQjtRQUFBO1FBQUE7TUFBQTtNQUp0QjtJQUFBO2dCQUFBOzs7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTs7OztJQUM0QztJQUN0QjtJQUNBO0lBSHRCLFNBQzRDLFVBQ3RCLFVBQ0EsU0FIdEI7O0lBQUE7SUFBQTtJQUFBLFNBQUEsbUJBQUE7Ozs7O0lBS0E7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO01BQUE7TUFJdUI7UUFBQTtRQUFBO01BQUE7TUFKdkI7SUFBQTtnQkFBQTs7Ozs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBOzs7O0lBQzhDO0lBQ3ZCO0lBQ0E7SUFIdkIsU0FDOEMsVUFDdkIsVUFDQSxTQUh2Qjs7SUFBQTtJQUFBO0lBQUEsU0FBQSxtQkFBQTs7Ozs7SUFLQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFJWTtRQUFBO1FBQUE7TUFBQTtNQUpaO0lBQUE7Z0JBQUE7Ozs7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBRVk7Z0JBQUE7a0JBRlo7UUFBQTtRQUFBO01BQUE7SUFBQTs7OztJQUN3QztJQUM1QjtJQUNBO0lBSFosU0FDd0MsV0FDNUIsV0FDQSxVQUhaOztJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTs7Ozs7SUFLQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFJWTtRQUFBO1FBQUE7TUFBQTtNQUpaO0lBQUE7Z0JBQUE7Ozs7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBRVk7a0JBRlo7UUFBQTtRQUFBO01BQUE7SUFBQTs7OztJQUNtQztJQUN2QjtJQUNBO0lBSFosU0FDbUMsV0FDdkIsV0FDQSxVQUhaOztJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTs7Ozs7Ozs7Ozs7OztJQWxLSjtnQkFBQTs7Ozs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtnQkFBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBRTBFO0lBQ3RFO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFHc0I7SUFDdEI7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBeUI7SUFDNEU7SUFDckc7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQU9NO0lBQ047TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BQXNFO1FBQUE7UUFBQTtNQUFBO01BQXRFO0lBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBQTtnQkFBQTtnQkFBQTs7Ozs7O0lBQUE7S0FBQTtnQkFBQTtNQUFBO0lBQUE7SUFBZ0c7SUFDNUY7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQTREa0I7SUFDbEI7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQWNrQjtJQUNsQjtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBU2tCO0lBQ2xCO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFzQmtCO0lBQ2xCO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFLb0Y7SUFDN0U7SUFDWDtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQUE7Ozs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQStHO0lBQy9HO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFHaUQ7SUFDakQ7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUdpRDtJQUNqRDtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBR2lEO0lBQ2pEO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFJbUU7SUFDbkU7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUlxRTtJQUNyRTtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBSWlEO0lBQ2pEO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFJaUQ7SUFDakQ7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBb0c7SUFDakY7Ozs7SUF2S3NEO0lBRHZEO0lBQ0E7SUFDQTtJQUEwQjtJQUZoRCxTQUM2RSxVQUR2RCxVQUNBLFVBQ0EsVUFBMEIsU0FGaEQ7SUFHeUI7SUFBckIsVUFBcUIsU0FBckI7SUFJeUI7SUFBekIsVUFBeUIsU0FBekI7SUFFSztJQUFMLFVBQUssU0FBTDtJQVFBO0lBQ3FCO0lBQWpCLFVBQWlCLFNBQWpCO0lBNkRpQjtJQUFqQixVQUFpQixTQUFqQjtJQWVpQjtJQUFqQixVQUFpQixVQUFqQjtJQVVpQjtJQUFqQixVQUFpQixVQUFqQjtJQXVCeUI7SUFBekIsVUFBeUIsVUFBekI7SUFPK0Q7SUFBbkUsVUFBbUUsVUFBbkU7SUFDWTtJQUFaLFVBQVksVUFBWjtJQUlZO0lBQVosVUFBWSxVQUFaO0lBSVk7SUFBWixVQUFZLFVBQVo7SUFJc0I7SUFBdEIsVUFBc0IsVUFBdEI7SUFLdUI7SUFBdkIsVUFBdUIsVUFBdkI7SUFLWTtJQUFaLFVBQVksVUFBWjtJQUtZO0lBQVosVUFBWSxVQUFaO0lBS3lEO0lBQXpELFVBQXlELFVBQXpEOzs7OztJQ3ZLSjtnQkFBQTs7Ozs7Ozs7Ozs7Ozs7OztJQUFBO0tBQUE7Z0JBQUE7OztJQUFBOzs7In0=



// WEBPACK FOOTER //
// ./src/app/payment/payment-page/payment-page.component.ngfactory.ts